/* tslint:disable */
/* eslint-disable */
/**
 * OnData.Encription
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddSubsetMasterTablesInput
 */
export interface AddSubsetMasterTablesInput {
    /**
     * 
     * @type {number}
     * @memberof AddSubsetMasterTablesInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddSubsetMasterTablesInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {Array<SubsetMasterTableInput>}
     * @memberof AddSubsetMasterTablesInput
     */
    'masterTables'?: Array<SubsetMasterTableInput> | null;
}
/**
 * 
 * @export
 * @interface AlertAndTime
 */
export interface AlertAndTime {
    /**
     * 
     * @type {number}
     * @memberof AlertAndTime
     */
    'no'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AlertAndTime
     */
    'alert'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertAndTime
     */
    'isWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertAndTime
     */
    'alertTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AlertAndTime
     */
    'databaseId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlertAndTime
     */
    'isObfuscation'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertAndTime
     */
    'parameters'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertAndTime
     */
    'actionArgs'?: Array<string> | null;
    /**
     * 
     * @type {LastActivityKind}
     * @memberof AlertAndTime
     */
    'kind'?: LastActivityKind;
    /**
     * 
     * @type {string}
     * @memberof AlertAndTime
     */
    'receipt'?: string | null;
}
/**
 * 
 * @export
 * @interface ClientAccessPolicyDto
 */
export interface ClientAccessPolicyDto {
    /**
     * 
     * @type {number}
     * @memberof ClientAccessPolicyDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientAccessPolicyDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClientAccessPolicyDto
     */
    'databaseIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClientAccessPolicyDto
     */
    'fileTemplateIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ClientAccessPolicyResponseDto
 */
export interface ClientAccessPolicyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ClientAccessPolicyResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientAccessPolicyResponseDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {Array<DatabaseResponseDto>}
     * @memberof ClientAccessPolicyResponseDto
     */
    'databaseList'?: Array<DatabaseResponseDto> | null;
    /**
     * 
     * @type {Array<FileEncryptionTemplateDto>}
     * @memberof ClientAccessPolicyResponseDto
     */
    'fileTemplateList'?: Array<FileEncryptionTemplateDto> | null;
}
/**
 * 
 * @export
 * @interface ClientManageDto
 */
export interface ClientManageDto {
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {ClientType}
     * @memberof ClientManageDto
     */
    'clientType'?: ClientType;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'softwareVersion'?: string | null;
    /**
     * 
     * @type {ClientStatus}
     * @memberof ClientManageDto
     */
    'status'?: ClientStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ClientManageDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'osInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'ipAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'remark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'registerAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'registerByUser'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r1UserFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r1UserLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r1Username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'reviewedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'reviewedByUser'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r2UserFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r2UserLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r2Username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'revokedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'revokedByUser'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r3UserFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r3UserLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r3Username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'suspendedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'suspendedByUser'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r4UserFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r4UserLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r4Username'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ClientStatus {
    PendingApproval = 0,
    Rejected = 1,
    Enabled = 2,
    Suspend = 3,
    Revoked = 100
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ClientType {
    ClassicalInternal = 0,
    DataDriver = 1,
    EncryptionTool = 2,
    ShareSecretDataDriver = 3,
    ShareSecretEncryptionTool = 4,
    SecureFileApp = 5,
    DataManagerService = 6,
    DataAnalyzerService = 7
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CloudProvider {
    Azure = 1,
    AzureUSGovernment = 2,
    Aws = 3,
    Gcp = 4
}

/**
 * 
 * @export
 * @interface CopyFileTemplateMappingInput
 */
export interface CopyFileTemplateMappingInput {
    /**
     * 
     * @type {number}
     * @memberof CopyFileTemplateMappingInput
     */
    'templateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CopyFileTemplateMappingInput
     */
    'copyFromTemplateId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CopyFileTemplateMappingInput
     */
    'includeObfsRule'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateDataInfoTypeInput
 */
export interface CreateDataInfoTypeInput {
    /**
     * 
     * @type {string}
     * @memberof CreateDataInfoTypeInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDataInfoTypeInput
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDataInfoTypeInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<DataType>}
     * @memberof CreateDataInfoTypeInput
     */
    'dataTypes'?: Array<DataType> | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDataInfoTypeInput
     */
    'minLength'?: number | null;
    /**
     * 
     * @type {Array<DetectPattern>}
     * @memberof CreateDataInfoTypeInput
     */
    'detectPatterns'?: Array<DetectPattern> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDataInfoTypeInput
     */
    'validateFunction'?: string | null;
    /**
     * 
     * @type {Array<KeywordRule>}
     * @memberof CreateDataInfoTypeInput
     */
    'keywordRules'?: Array<KeywordRule> | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDataInfoTypeInput
     */
    'defaultSecondClassification'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDataInfoTypeInput
     */
    'defaultEncryptionRule'?: number;
}
/**
 * 
 * @export
 * @interface CreateEncryptionKeyInput
 */
export interface CreateEncryptionKeyInput {
    /**
     * 
     * @type {string}
     * @memberof CreateEncryptionKeyInput
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateObfuscationRuleInput
 */
export interface CreateObfuscationRuleInput {
    /**
     * 
     * @type {string}
     * @memberof CreateObfuscationRuleInput
     */
    'ruleName': string;
    /**
     * 
     * @type {ObfuscationDataType}
     * @memberof CreateObfuscationRuleInput
     */
    'dataType': ObfuscationDataType;
    /**
     * 
     * @type {ObfuscationRuleType}
     * @memberof CreateObfuscationRuleInput
     */
    'ruleType': ObfuscationRuleType;
    /**
     * 
     * @type {number}
     * @memberof CreateObfuscationRuleInput
     */
    'databaseId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateObfuscationRuleInput
     */
    'tableId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateObfuscationRuleInput
     */
    'fieldId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateObfuscationRuleInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateObfuscationRuleInput
     */
    'valuesList'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateObfuscationRuleInput
     */
    'rangeValues'?: Array<string> | null;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof CreateObfuscationRuleInput
     */
    'rangeBorders'?: Array<boolean> | null;
    /**
     * 
     * @type {InferredInfo}
     * @memberof CreateObfuscationRuleInput
     */
    'inferredType': InferredInfo;
}
/**
 * 
 * @export
 * @interface DataAccessPolicyResponseDto
 */
export interface DataAccessPolicyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DataAccessPolicyResponseDto
     */
    'validationKeyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataAccessPolicyResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataAccessPolicyResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataAccessPolicyResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessPolicyResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessPolicyResponseDto
     */
    'fingerPrint'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessPolicyResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DataAccessPolicyResponseDto
     */
    'isManaged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataAccessPolicyResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataAccessPolicyResponseDto
     */
    'oidcDomain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessPolicyResponseDto
     */
    'validationKey'?: string | null;
}
/**
 * 
 * @export
 * @interface DataAccessTokenCreationInput
 */
export interface DataAccessTokenCreationInput {
    /**
     * 
     * @type {number}
     * @memberof DataAccessTokenCreationInput
     */
    'databaseId': number;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenCreationInput
     */
    'tokenName': string;
    /**
     * 
     * @type {number}
     * @memberof DataAccessTokenCreationInput
     */
    'consumerUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenCreationInput
     */
    'expirationTime': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataAccessTokenCreationInput
     */
    'dataAccessRoles': Array<string>;
}
/**
 * 
 * @export
 * @interface DataAccessTokenDto
 */
export interface DataAccessTokenDto {
    /**
     * 
     * @type {number}
     * @memberof DataAccessTokenDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenDto
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataAccessTokenDto
     */
    'requestUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenDto
     */
    'requestUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenDto
     */
    'expirationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenDto
     */
    'tokenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenDto
     */
    'consumerUserName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataAccessTokenDto
     */
    'consumerUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenDto
     */
    'dataAccessRoles'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataAccessTokenDto
     */
    'keyInvalidated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataAccessTokenDto
     */
    'tokenInvalidated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenDto
     */
    'token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessTokenDto
     */
    'jti'?: string | null;
}
/**
 * 
 * @export
 * @interface DataAccessTokenDtoPaginationResult
 */
export interface DataAccessTokenDtoPaginationResult {
    /**
     * 
     * @type {Array<DataAccessTokenDto>}
     * @memberof DataAccessTokenDtoPaginationResult
     */
    'items'?: Array<DataAccessTokenDto> | null;
    /**
     * 
     * @type {number}
     * @memberof DataAccessTokenDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface DataClassificationRuleDto
 */
export interface DataClassificationRuleDto {
    /**
     * 
     * @type {number}
     * @memberof DataClassificationRuleDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataClassificationRuleDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataClassificationRuleDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataClassificationRuleDto
     */
    'targetClassification'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataClassificationRuleDto
     */
    'ruleDisplayTree'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataClassificationRuleDto
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataClassificationRuleDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataClassificationRuleDto
     */
    'activeRule'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataClassificationRuleDto
     */
    'createTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DataClassificationRuleDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataClassificationRuleDto
     */
    'predecessorId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataClassificationRuleDto
     */
    'serialNumber'?: number;
}
/**
 * 
 * @export
 * @interface DataClassificationRuleInput
 */
export interface DataClassificationRuleInput {
    /**
     * 
     * @type {number}
     * @memberof DataClassificationRuleInput
     */
    'ruleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataClassificationRuleInput
     */
    'displayName': string;
    /**
     * 
     * @type {number}
     * @memberof DataClassificationRuleInput
     */
    'targetClassification'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataClassificationRuleInput
     */
    'ruleDisplayTree': string;
    /**
     * 
     * @type {number}
     * @memberof DataClassificationRuleInput
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataClassificationRuleInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataClassificationRuleInput
     */
    'activeRule'?: boolean;
}
/**
 * 
 * @export
 * @interface DataInfoTypeResponseDto
 */
export interface DataInfoTypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DataInfoTypeResponseDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataInfoTypeResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataInfoTypeResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataInfoTypeResponseDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataInfoTypeResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataInfoTypeResponseDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {Array<DataType>}
     * @memberof DataInfoTypeResponseDto
     */
    'dataTypes'?: Array<DataType> | null;
    /**
     * 
     * @type {number}
     * @memberof DataInfoTypeResponseDto
     */
    'minLength'?: number | null;
    /**
     * 
     * @type {Array<DetectPattern>}
     * @memberof DataInfoTypeResponseDto
     */
    'detectPatterns'?: Array<DetectPattern> | null;
    /**
     * 
     * @type {string}
     * @memberof DataInfoTypeResponseDto
     */
    'validateFunction'?: string | null;
    /**
     * 
     * @type {Array<KeywordRule>}
     * @memberof DataInfoTypeResponseDto
     */
    'keywordRules'?: Array<KeywordRule> | null;
    /**
     * 
     * @type {number}
     * @memberof DataInfoTypeResponseDto
     */
    'defaultSecondClassification'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataInfoTypeResponseDto
     */
    'defaultEncryptionRule'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DataInfoTypeResponseDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DataKindCategory {
    FileTemplate = 0,
    Database = 1,
    ParquetFile = 2
}

/**
 * 
 * @export
 * @interface DataProtectionRuleDto
 */
export interface DataProtectionRuleDto {
    /**
     * 
     * @type {number}
     * @memberof DataProtectionRuleDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataProtectionRuleDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataProtectionRuleDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataProtectionRuleDto
     */
    'targetEncryptionRule'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataProtectionRuleDto
     */
    'ruleDisplayTree'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataProtectionRuleDto
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataProtectionRuleDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataProtectionRuleDto
     */
    'activeRule'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataProtectionRuleDto
     */
    'createTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DataProtectionRuleDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataProtectionRuleDto
     */
    'predecessorId'?: number | null;
}
/**
 * 
 * @export
 * @interface DataProtectionRuleInput
 */
export interface DataProtectionRuleInput {
    /**
     * 
     * @type {number}
     * @memberof DataProtectionRuleInput
     */
    'ruleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataProtectionRuleInput
     */
    'displayName': string;
    /**
     * 
     * @type {number}
     * @memberof DataProtectionRuleInput
     */
    'targetEncryptionRule'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataProtectionRuleInput
     */
    'ruleDisplayTree': string;
    /**
     * 
     * @type {number}
     * @memberof DataProtectionRuleInput
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataProtectionRuleInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataProtectionRuleInput
     */
    'activeRule'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DataType {
    String = 0,
    Number = 1,
    Date = 2
}

/**
 * 
 * @export
 * @interface DatabaseClientAccessPolicyDto
 */
export interface DatabaseClientAccessPolicyDto {
    /**
     * 
     * @type {number}
     * @memberof DatabaseClientAccessPolicyDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseClientAccessPolicyDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseClientAccessPolicyDto
     */
    'accessibleClientIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DatabaseClientAccessPolicyResponseDto
 */
export interface DatabaseClientAccessPolicyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DatabaseClientAccessPolicyResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseClientAccessPolicyResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {Array<ClientManageDto>}
     * @memberof DatabaseClientAccessPolicyResponseDto
     */
    'clients'?: Array<ClientManageDto> | null;
}
/**
 * 
 * @export
 * @interface DatabaseOptionResponseDto
 */
export interface DatabaseOptionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DatabaseOptionResponseDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseOptionResponseDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseOptionResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof DatabaseOptionResponseDto
     */
    'databaseType'?: DatabaseType;
}
/**
 * 
 * @export
 * @interface DatabaseResponseDto
 */
export interface DatabaseResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'retentionDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'engineId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'engineVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'engineEdition'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof DatabaseResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'encryptionKeyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'sizeText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'historicalSnapshotId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'snapshotId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'newSnapshotId'?: number | null;
    /**
     * 
     * @type {UpgradeStatus}
     * @memberof DatabaseResponseDto
     */
    'upgradeStatus'?: UpgradeStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'encryptionKeyChanged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'fieldsChanged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'isEncrypted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'subsetLimit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'autoClassified'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DatabaseType {
    MySQL = 1,
    PostgreSQL = 2,
    SQLServer = 3,
    MongoDB = 4,
    MariaDB = 5,
    Oracle = 6,
    DB2 = 7,
    Hana = 8,
    Snowflake = 9,
    CosmosDB = 10
}

/**
 * 
 * @export
 * @interface DetectPattern
 */
export interface DetectPattern {
    /**
     * 
     * @type {string}
     * @memberof DetectPattern
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DetectPattern
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetectPattern
     */
    'regex'?: string | null;
}
/**
 * 
 * @export
 * @interface DownloadAuthenticateInput
 */
export interface DownloadAuthenticateInput {
    /**
     * 
     * @type {number}
     * @memberof DownloadAuthenticateInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadAuthenticateInput
     */
    'encryptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadAuthenticateInput
     */
    'downloadId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DownloadAuthenticateInput
     */
    'publicKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DownloadAuthenticateInput
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface EDIRule
 */
export interface EDIRule {
    /**
     * 
     * @type {string}
     * @memberof EDIRule
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EDIRule
     */
    'segment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EDIRule
     */
    'anchor'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EDIRule
     */
    'anchorValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EDIRule
     */
    'precedingSegment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EDIRule
     */
    'precedingAnchor'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EDIRule
     */
    'precedingAnchorValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EDIRule
     */
    'element'?: number;
    /**
     * 
     * @type {number}
     * @memberof EDIRule
     */
    'start'?: number | null;
}
/**
 * 
 * @export
 * @interface EditFileTemplateInput
 */
export interface EditFileTemplateInput {
    /**
     * 
     * @type {number}
     * @memberof EditFileTemplateInput
     */
    'templateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditFileTemplateInput
     */
    'encryptionKeyId'?: number | null;
    /**
     * 
     * @type {Array<FileColumn>}
     * @memberof EditFileTemplateInput
     */
    'columns'?: Array<FileColumn> | null;
}
/**
 * 
 * @export
 * @interface EditObfuscationMappingInput
 */
export interface EditObfuscationMappingInput {
    /**
     * 
     * @type {number}
     * @memberof EditObfuscationMappingInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditObfuscationMappingInput
     */
    'tableId': number;
    /**
     * 
     * @type {Array<FieldObfsMappingInput>}
     * @memberof EditObfuscationMappingInput
     */
    'obfsMappings'?: Array<FieldObfsMappingInput> | null;
}
/**
 * 
 * @export
 * @interface EncryptionDashboardResponseDto
 */
export interface EncryptionDashboardResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionDashboardResponseDto
     */
    'encryptionSuccessCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionDashboardResponseDto
     */
    'encryptionWarningCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionDashboardResponseDto
     */
    'encryptionFailedCount'?: number;
    /**
     * 
     * @type {Array<AlertAndTime>}
     * @memberof EncryptionDashboardResponseDto
     */
    'encryptionAlerts'?: Array<AlertAndTime> | null;
}
/**
 * 
 * @export
 * @interface EncryptionFailedLogInput
 */
export interface EncryptionFailedLogInput {
    /**
     * 
     * @type {number}
     * @memberof EncryptionFailedLogInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionFailedLogInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionFailedLogInput
     */
    'encryptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionFailedLogInput
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionFailedLogInput
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionFailedLogInput
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptionFailedLogInput
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionFailedLogInput
     */
    'failedCount'?: number;
}
/**
 * 
 * @export
 * @interface EncryptionJobResponseDto
 */
export interface EncryptionJobResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionJobResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionJobResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionJobResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionJobResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptionJobResponseDto
     */
    'retentionDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionJobResponseDto
     */
    'engineId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionJobResponseDto
     */
    'engineVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionJobResponseDto
     */
    'engineEdition'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof EncryptionJobResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {number}
     * @memberof EncryptionJobResponseDto
     */
    'encryptionKeyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionJobResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof EncryptionJobResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionJobResponseDto
     */
    'sizeText'?: string | null;
    /**
     * 
     * @type {EncryptionStatus}
     * @memberof EncryptionJobResponseDto
     */
    'encryptionStatus'?: EncryptionStatus;
    /**
     * 
     * @type {string}
     * @memberof EncryptionJobResponseDto
     */
    'encryptionAlert'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionJobResponseDto
     */
    'lastEncryptionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionJobResponseDto
     */
    'encryptionFailedLog'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionJobResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface EncryptionKeyChange
 */
export interface EncryptionKeyChange {
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionKeyChange
     */
    'isChanged'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyChange
     */
    'fromId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyChange
     */
    'toId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyChange
     */
    'fromName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyChange
     */
    'toName'?: string | null;
}
/**
 * 
 * @export
 * @interface EncryptionKeyResponseDto
 */
export interface EncryptionKeyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionKeyResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface EncryptionLogInput
 */
export interface EncryptionLogInput {
    /**
     * 
     * @type {string}
     * @memberof EncryptionLogInput
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptionLogInput
     */
    'encryptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionLogInput
     */
    'totalMinute'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionLogInput
     */
    'isSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EncryptionLogInput
     */
    'exception'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionLogInput
     */
    'log'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionLogInput
     */
    'failedLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionLogInput
     */
    'mappings'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionLogInput
     */
    'isEncoded'?: boolean;
    /**
     * 
     * @type {OperatingMode}
     * @memberof EncryptionLogInput
     */
    'operatingMode'?: OperatingMode;
    /**
     * 
     * @type {OperatingEnvironment}
     * @memberof EncryptionLogInput
     */
    'operatingEnvironment'?: OperatingEnvironment;
}
/**
 * 
 * @export
 * @interface EncryptionResponseDto
 */
export interface EncryptionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionResponseDto
     */
    'encryptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionResponseDto
     */
    'backupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'backupReceivedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'backupCreatedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptionResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'sizeText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptionResponseDto
     */
    'backupSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'backupSizeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'restoreLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'backupLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'exception'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'mappings'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'dllVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptionResponseDto
     */
    'encryptionServerId'?: number | null;
    /**
     * 
     * @type {EncryptionStatus}
     * @memberof EncryptionResponseDto
     */
    'status'?: EncryptionStatus;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'statusText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionResponseDto
     */
    'encryptionFailedLog'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionResponseDto
     */
    'isFileDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionResponseDto
     */
    'isObfuscation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionResponseDto
     */
    'isDecryption'?: boolean;
}
/**
 * 
 * @export
 * @interface EncryptionRule
 */
export interface EncryptionRule {
    /**
     * 
     * @type {number}
     * @memberof EncryptionRule
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRule
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRule
     */
    'sampleInput'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRule
     */
    'sampleOutput'?: string | null;
    /**
     * 
     * @type {Encryptor}
     * @memberof EncryptionRule
     */
    'encryptor'?: Encryptor;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionRule
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface EncryptionRuleResponseDto
 */
export interface EncryptionRuleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionRuleResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRuleResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRuleResponseDto
     */
    'sampleInput'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRuleResponseDto
     */
    'sampleOutput'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRuleResponseDto
     */
    'dataTypes'?: string | null;
    /**
     * 
     * @type {Encryptor}
     * @memberof EncryptionRuleResponseDto
     */
    'encryptor'?: Encryptor;
    /**
     * 
     * @type {string}
     * @memberof EncryptionRuleResponseDto
     */
    'encryptorText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionRuleResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface EncryptionSettingChangesResponseDto
 */
export interface EncryptionSettingChangesResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionSettingChangesResponseDto
     */
    'hasSnapshot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionSettingChangesResponseDto
     */
    'isChanged'?: boolean;
    /**
     * 
     * @type {EncryptionKeyChange}
     * @memberof EncryptionSettingChangesResponseDto
     */
    'encryptionKeyChange'?: EncryptionKeyChange;
    /**
     * 
     * @type {Array<FieldWithEncryptorInfo>}
     * @memberof EncryptionSettingChangesResponseDto
     */
    'fieldsAdded'?: Array<FieldWithEncryptorInfo> | null;
    /**
     * 
     * @type {Array<FieldWithEncryptorInfo>}
     * @memberof EncryptionSettingChangesResponseDto
     */
    'fieldsRemoved'?: Array<FieldWithEncryptorInfo> | null;
    /**
     * 
     * @type {Array<FieldChanged>}
     * @memberof EncryptionSettingChangesResponseDto
     */
    'fieldsChanged'?: Array<FieldChanged> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EncryptionStatus {
    NotStarted = 0,
    InProgress = 1,
    Success = 2,
    Failed = 3,
    Warning = 4
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum Encryptor {
    Alphabetic = 1,
    Alphanumeric = 2,
    CreditCard = 3,
    Date = 4,
    Email = 5,
    HexString = 6,
    Numeric = 7,
    String = 8,
    Integer = 9,
    Float = 10,
    Money = 11,
    UInteger = 12,
    MonthDay = 13,
    XML = 14,
    SSN = 15,
    ValidatedCardNumber = 16,
    Utf8String = 17
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ExtraIgnoreItem {
    None = 0,
    RowVersionGeneratedAlways = 1,
    TransitiveIdentity = 2
}

/**
 * 
 * @export
 * @interface FieldChanged
 */
export interface FieldChanged {
    /**
     * 
     * @type {string}
     * @memberof FieldChanged
     */
    'schemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldChanged
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldChanged
     */
    'fieldName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldChanged
     */
    'isEncryptorChanged'?: boolean;
    /**
     * 
     * @type {FieldWithEncryptorInfo}
     * @memberof FieldChanged
     */
    'fromFieldInfo'?: FieldWithEncryptorInfo;
    /**
     * 
     * @type {FieldWithEncryptorInfo}
     * @memberof FieldChanged
     */
    'toFieldInfo'?: FieldWithEncryptorInfo;
}
/**
 * 
 * @export
 * @interface FieldNameQueryDto
 */
export interface FieldNameQueryDto {
    /**
     * 
     * @type {number}
     * @memberof FieldNameQueryDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldNameQueryDto
     */
    'tableId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldNameQueryDto
     */
    'fieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FieldNameQueryDto
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldNameQueryDto
     */
    'schemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldNameQueryDto
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldNameQueryDto
     */
    'fieldName'?: string | null;
}
/**
 * 
 * @export
 * @interface FieldObfsMappingDto
 */
export interface FieldObfsMappingDto {
    /**
     * 
     * @type {number}
     * @memberof FieldObfsMappingDto
     */
    'fieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FieldObfsMappingDto
     */
    'fieldName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldObfsMappingDto
     */
    'dataType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FieldObfsMappingDto
     */
    'maxLength'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldObfsMappingDto
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldObfsMappingDto
     */
    'scale'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldObfsMappingDto
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldObfsMappingDto
     */
    'obfuscationRuleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldObfsMappingDto
     */
    'position'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FieldObfsMappingDto
     */
    'isIdentity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldObfsMappingDto
     */
    'isComputed'?: boolean;
    /**
     * 
     * @type {ExtraIgnoreItem}
     * @memberof FieldObfsMappingDto
     */
    'extraIgnoreItem'?: ExtraIgnoreItem;
    /**
     * 
     * @type {boolean}
     * @memberof FieldObfsMappingDto
     */
    'isNullable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldObfsMappingDto
     */
    'isPrimaryKey'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldObfsMappingDto
     */
    'isForeignKey'?: boolean;
}
/**
 * 
 * @export
 * @interface FieldObfsMappingInput
 */
export interface FieldObfsMappingInput {
    /**
     * 
     * @type {number}
     * @memberof FieldObfsMappingInput
     */
    'fieldId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FieldObfsMappingInput
     */
    'removeMapping'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FieldObfsMappingInput
     */
    'obfuscationRuleId'?: number | null;
}
/**
 * 
 * @export
 * @interface FieldResponseDto
 */
export interface FieldResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FieldResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldResponseDto
     */
    'tableId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FieldResponseDto
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldResponseDto
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FieldResponseDto
     */
    'fieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FieldResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldResponseDto
     */
    'alias'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldResponseDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FieldResponseDto
     */
    'position'?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldResponseDto
     */
    'maxLength'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldResponseDto
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldResponseDto
     */
    'scale'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldResponseDto
     */
    'isNullable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FieldResponseDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldResponseDto
     */
    'dataInfoTypeId'?: string | null;
}
/**
 * 
 * @export
 * @interface FieldWithEncryptorInfo
 */
export interface FieldWithEncryptorInfo {
    /**
     * 
     * @type {string}
     * @memberof FieldWithEncryptorInfo
     */
    'schemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldWithEncryptorInfo
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldWithEncryptorInfo
     */
    'fieldName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldWithEncryptorInfo
     */
    'isView'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FieldWithEncryptorInfo
     */
    'dataType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldWithEncryptorInfo
     */
    'encryptionRuleName'?: string | null;
    /**
     * 
     * @type {Encryptor}
     * @memberof FieldWithEncryptorInfo
     */
    'encryptor'?: Encryptor;
    /**
     * 
     * @type {number}
     * @memberof FieldWithEncryptorInfo
     */
    'encryptionRuleId'?: number | null;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof FieldWithEncryptorInfo
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof FieldWithEncryptorInfo
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {MaskingRule}
     * @memberof FieldWithEncryptorInfo
     */
    'maskingRule'?: MaskingRule;
    /**
     * 
     * @type {string}
     * @memberof FieldWithEncryptorInfo
     */
    'maskingValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FieldWithEncryptorInfo
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldWithEncryptorInfo
     */
    'scale'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldWithEncryptorInfo
     */
    'isIdentity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldWithEncryptorInfo
     */
    'isComputed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldWithEncryptorInfo
     */
    'isPrimaryKey'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FieldWithEncryptorInfo
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FieldWithEncryptorInfo
     */
    'position'?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldWithEncryptorInfo
     */
    'maxLength'?: number | null;
}
/**
 * 
 * @export
 * @interface FileColumn
 */
export interface FileColumn {
    /**
     * 
     * @type {string}
     * @memberof FileColumn
     */
    'columnName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileColumn
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileColumn
     */
    'startPosition'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileColumn
     */
    'length'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileColumn
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileColumn
     */
    'description'?: string | null;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof FileColumn
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof FileColumn
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileColumn
     */
    'dataType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileColumn
     */
    'parquetDataType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileColumn
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileColumn
     */
    'scale'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileColumn
     */
    'encryptionRuleId'?: number | null;
    /**
     * 
     * @type {Encryptor}
     * @memberof FileColumn
     */
    'encryptor'?: Encryptor;
    /**
     * 
     * @type {number}
     * @memberof FileColumn
     */
    'obfuscationRuleId'?: number | null;
    /**
     * 
     * @type {EDIRule}
     * @memberof FileColumn
     */
    'ediRule'?: EDIRule;
}
/**
 * 
 * @export
 * @interface FileColumnObfuscationInfo
 */
export interface FileColumnObfuscationInfo {
    /**
     * 
     * @type {number}
     * @memberof FileColumnObfuscationInfo
     */
    'obfuscationRuleId'?: number;
    /**
     * 
     * @type {ObfuscationDataType}
     * @memberof FileColumnObfuscationInfo
     */
    'ruleDataType'?: ObfuscationDataType;
    /**
     * 
     * @type {ObfuscationRuleType}
     * @memberof FileColumnObfuscationInfo
     */
    'ruleType'?: ObfuscationRuleType;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileColumnObfuscationInfo
     */
    'valuesList'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FileColumnObfuscationInfo
     */
    'rangeLowerValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileColumnObfuscationInfo
     */
    'rangeUpperValue'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileColumnObfuscationInfo
     */
    'rangeLowerBorder'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileColumnObfuscationInfo
     */
    'rangeUpperBorder'?: boolean;
}
/**
 * 
 * @export
 * @interface FileEncryptionKeyResponseDto
 */
export interface FileEncryptionKeyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FileEncryptionKeyResponseDto
     */
    'encryptedAesKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileEncryptionKeyResponseDto
     */
    'tweak'?: string | null;
}
/**
 * 
 * @export
 * @interface FileEncryptionTemplateDto
 */
export interface FileEncryptionTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof FileEncryptionTemplateDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileEncryptionTemplateDto
     */
    'templateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileEncryptionTemplateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {FileTemplateKind}
     * @memberof FileEncryptionTemplateDto
     */
    'kind'?: FileTemplateKind;
    /**
     * 
     * @type {string}
     * @memberof FileEncryptionTemplateDto
     */
    'uploadTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileEncryptionTemplateDto
     */
    'encryptionKeyId'?: number | null;
    /**
     * 
     * @type {Array<FileColumn>}
     * @memberof FileEncryptionTemplateDto
     */
    'columns'?: Array<FileColumn> | null;
    /**
     * 
     * @type {string}
     * @memberof FileEncryptionTemplateDto
     */
    'delimitingChar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileEncryptionTemplateDto
     */
    'escapeChar'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FileEncryptionTemplateDto
     */
    'columnCounts'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof FileEncryptionTemplateDto
     */
    'jsonSchema'?: string | null;
    /**
     * 
     * @type {FileTemplateStatus}
     * @memberof FileEncryptionTemplateDto
     */
    'status'?: FileTemplateStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FileEncryptionTemplateDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {{ [key: string]: FileColumnObfuscationInfo; }}
     * @memberof FileEncryptionTemplateDto
     */
    'obfuscationRulesMap'?: { [key: string]: FileColumnObfuscationInfo; } | null;
    /**
     * 
     * @type {string}
     * @memberof FileEncryptionTemplateDto
     */
    'fileName'?: string | null;
}
/**
 * 
 * @export
 * @interface FileTemplateClientAccessPolicyDto
 */
export interface FileTemplateClientAccessPolicyDto {
    /**
     * 
     * @type {number}
     * @memberof FileTemplateClientAccessPolicyDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileTemplateClientAccessPolicyDto
     */
    'templateId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileTemplateClientAccessPolicyDto
     */
    'accessibleClientIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface FileTemplateClientAccessPolicyResponseDto
 */
export interface FileTemplateClientAccessPolicyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileTemplateClientAccessPolicyResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileTemplateClientAccessPolicyResponseDto
     */
    'templateId'?: number;
    /**
     * 
     * @type {Array<ClientManageDto>}
     * @memberof FileTemplateClientAccessPolicyResponseDto
     */
    'clients'?: Array<ClientManageDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum FileTemplateKind {
    CSV = 0,
    FixedWidth = 1,
    JsonSample = 2,
    EDI = 3,
    ParquetSample = 4
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum FileTemplateStatus {
    Uploaded = 0,
    KeyAssigned = 1,
    ColumnsLabeled = 2,
    Complete = 3
}

/**
 * 
 * @export
 * @interface GetBackupFilesWithUriInput
 */
export interface GetBackupFilesWithUriInput {
    /**
     * 
     * @type {number}
     * @memberof GetBackupFilesWithUriInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBackupFilesWithUriInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBackupFilesWithUriInput
     */
    'encryptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetBackupFilesWithUriInput
     */
    'publicKeyXml': string;
    /**
     * 
     * @type {string}
     * @memberof GetBackupFilesWithUriInput
     */
    'validationCode': string;
}
/**
 * 
 * @export
 * @interface GetEncryptionFilesWithUriInput
 */
export interface GetEncryptionFilesWithUriInput {
    /**
     * 
     * @type {number}
     * @memberof GetEncryptionFilesWithUriInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetEncryptionFilesWithUriInput
     */
    'encryptionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetEncryptionFilesWithUriInput
     */
    'publicKeyXml'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEncryptionFilesWithUriInput
     */
    'validationCode'?: string | null;
}
/**
 * 
 * @export
 * @interface HintEntry
 */
export interface HintEntry {
    /**
     * 
     * @type {string}
     * @memberof HintEntry
     */
    'schemaName': string;
    /**
     * 
     * @type {string}
     * @memberof HintEntry
     */
    'newSchemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HintEntry
     */
    'oldTableName': string;
    /**
     * 
     * @type {string}
     * @memberof HintEntry
     */
    'newTableName': string;
    /**
     * 
     * @type {string}
     * @memberof HintEntry
     */
    'oldFieldName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HintEntry
     */
    'newFieldName'?: string | null;
}
/**
 * 
 * @export
 * @interface InferredInfo
 */
export interface InferredInfo {
    /**
     * 
     * @type {string}
     * @memberof InferredInfo
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InferredInfo
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof InferredInfo
     */
    'p'?: number;
    /**
     * 
     * @type {number}
     * @memberof InferredInfo
     */
    's'?: number;
    /**
     * 
     * @type {number}
     * @memberof InferredInfo
     */
    'pn'?: number;
    /**
     * 
     * @type {number}
     * @memberof InferredInfo
     */
    'pOra'?: number;
    /**
     * 
     * @type {number}
     * @memberof InferredInfo
     */
    'sOra'?: number;
    /**
     * 
     * @type {string}
     * @memberof InferredInfo
     */
    'sourceColumnType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InferredInfo
     */
    'sourceColumnName'?: string | null;
}
/**
 * 
 * @export
 * @interface InfoTypeValidateFunctionDto
 */
export interface InfoTypeValidateFunctionDto {
    /**
     * 
     * @type {string}
     * @memberof InfoTypeValidateFunctionDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeValidateFunctionDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface KeywordRule
 */
export interface KeywordRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof KeywordRule
     */
    'words'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof KeywordRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'scoreAdjustment'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum LastActivityKind {
    EncryptionJob = 0,
    ObfuscationJob = 1,
    ObfsRuleObsolete = 3
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum MaskingRule {
    None = 0,
    ReplaceWithCharacter = 1,
    ReplaceWithCharacterPreserveLastFour = 2,
    ReplaceWithDefaultDate = 3
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ObfuscationDataType {
    String = 0,
    DateTime = 1,
    Integer = 2,
    Numeric = 3
}

/**
 * 
 * @export
 * @interface ObfuscationMappingResponseDto
 */
export interface ObfuscationMappingResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ObfuscationMappingResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ObfuscationMappingResponseDto
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObfuscationMappingResponseDto
     */
    'engineVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObfuscationMappingResponseDto
     */
    'engineEdition'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof ObfuscationMappingResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {number}
     * @memberof ObfuscationMappingResponseDto
     */
    'obfsMappedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObfuscationMappingResponseDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ObfuscationRuleDto
 */
export interface ObfuscationRuleDto {
    /**
     * 
     * @type {number}
     * @memberof ObfuscationRuleDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ObfuscationRuleDto
     */
    'ruleName'?: string | null;
    /**
     * 
     * @type {ObfuscationDataType}
     * @memberof ObfuscationRuleDto
     */
    'dataType'?: ObfuscationDataType;
    /**
     * 
     * @type {ObfuscationRuleType}
     * @memberof ObfuscationRuleDto
     */
    'ruleType'?: ObfuscationRuleType;
    /**
     * 
     * @type {number}
     * @memberof ObfuscationRuleDto
     */
    'databaseId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ObfuscationRuleDto
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ObfuscationRuleDto
     */
    'tableId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ObfuscationRuleDto
     */
    'fieldId'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ObfuscationRuleDto
     */
    'valuesList'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ObfuscationRuleDto
     */
    'rangeValues'?: Array<string> | null;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof ObfuscationRuleDto
     */
    'rangeBorders'?: Array<boolean> | null;
    /**
     * 
     * @type {InferredInfo}
     * @memberof ObfuscationRuleDto
     */
    'inferredType'?: InferredInfo;
    /**
     * 
     * @type {string}
     * @memberof ObfuscationRuleDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {ObfuscationRuleStatus}
     * @memberof ObfuscationRuleDto
     */
    'status'?: ObfuscationRuleStatus;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ObfuscationRuleStatus {
    Enable = 0,
    Obsolete = 1
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ObfuscationRuleType {
    TableColumn = 0,
    ValueList = 1,
    ValueRange = 2,
    ClearData = 3
}

/**
 * 
 * @export
 * @interface ObfuscationRuleUsageBriefDto
 */
export interface ObfuscationRuleUsageBriefDto {
    /**
     * 
     * @type {Array<FieldNameQueryDto>}
     * @memberof ObfuscationRuleUsageBriefDto
     */
    'appliedFields'?: Array<FieldNameQueryDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ObfuscationRuleUsageBriefDto
     */
    'totalUsageCount'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum OperatingEnvironment {
    NonProduction = 0,
    Production = 1
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum OperatingMode {
    Encryption = 0,
    Decryption = 1,
    ApplyEncryptionSettings = 2
}

/**
 * 
 * @export
 * @interface OptionResponseDto
 */
export interface OptionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OptionResponseDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OptionResponseDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OptionResponseDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PrimaryClassification {
    Public = 0,
    Sensitive = 1,
    Confidential = 2,
    Regulated = 3
}

/**
 * 
 * @export
 * @interface ReportResultInput
 */
export interface ReportResultInput {
    /**
     * 
     * @type {number}
     * @memberof ReportResultInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportResultInput
     */
    'encryptionId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportResultInput
     */
    'isSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'log'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'exception'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'validationCode': string;
    /**
     * 
     * @type {Array<EncryptionFailedLogInput>}
     * @memberof ReportResultInput
     */
    'failedLogs'?: Array<EncryptionFailedLogInput> | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'dllVersion'?: string | null;
}
/**
 * 
 * @export
 * @interface RetrieveEncryptionKeyInput
 */
export interface RetrieveEncryptionKeyInput {
    /**
     * 
     * @type {string}
     * @memberof RetrieveEncryptionKeyInput
     */
    'publicKey': string;
    /**
     * 
     * @type {string}
     * @memberof RetrieveEncryptionKeyInput
     */
    'databaseName': string;
    /**
     * 
     * @type {boolean}
     * @memberof RetrieveEncryptionKeyInput
     */
    'isEncoded'?: boolean;
    /**
     * 
     * @type {OperatingEnvironment}
     * @memberof RetrieveEncryptionKeyInput
     */
    'operatingEnvironment'?: OperatingEnvironment;
    /**
     * 
     * @type {boolean}
     * @memberof RetrieveEncryptionKeyInput
     */
    'isToApplySettingChanges'?: boolean;
}
/**
 * 
 * @export
 * @interface RetrieveFileEncryptionKeyInput
 */
export interface RetrieveFileEncryptionKeyInput {
    /**
     * 
     * @type {string}
     * @memberof RetrieveFileEncryptionKeyInput
     */
    'publicKey': string;
    /**
     * 
     * @type {string}
     * @memberof RetrieveFileEncryptionKeyInput
     */
    'templateName': string;
    /**
     * 
     * @type {boolean}
     * @memberof RetrieveFileEncryptionKeyInput
     */
    'isEncoded'?: boolean;
}
/**
 * 
 * @export
 * @interface RetrieveMappingsByDbNameInput
 */
export interface RetrieveMappingsByDbNameInput {
    /**
     * 
     * @type {string}
     * @memberof RetrieveMappingsByDbNameInput
     */
    'databaseName': string;
    /**
     * 
     * @type {number}
     * @memberof RetrieveMappingsByDbNameInput
     */
    'encryptionId'?: number | null;
    /**
     * 
     * @type {OperatingMode}
     * @memberof RetrieveMappingsByDbNameInput
     */
    'operatingMode'?: OperatingMode;
}
/**
 * 
 * @export
 * @interface ScheduleEncryptionInput
 */
export interface ScheduleEncryptionInput {
    /**
     * 
     * @type {number}
     * @memberof ScheduleEncryptionInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScheduleEncryptionInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleEncryptionInput
     */
    'isObfuscation'?: boolean;
}
/**
 * 
 * @export
 * @interface SubsetMasterTableInput
 */
export interface SubsetMasterTableInput {
    /**
     * 
     * @type {number}
     * @memberof SubsetMasterTableInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubsetMasterTableInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubsetMasterTableInput
     */
    'schemaName': string;
    /**
     * 
     * @type {string}
     * @memberof SubsetMasterTableInput
     */
    'tableName': string;
    /**
     * 
     * @type {number}
     * @memberof SubsetMasterTableInput
     */
    'rowCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubsetMasterTableInput
     */
    'whereClause'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubsetMasterTableInput
     */
    'orderByClause'?: string | null;
}
/**
 * 
 * @export
 * @interface SubsetMasterTableResponseDto
 */
export interface SubsetMasterTableResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SubsetMasterTableResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubsetMasterTableResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubsetMasterTableResponseDto
     */
    'schemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubsetMasterTableResponseDto
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubsetMasterTableResponseDto
     */
    'rowCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubsetMasterTableResponseDto
     */
    'whereClause'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubsetMasterTableResponseDto
     */
    'orderByClause'?: string | null;
}
/**
 * 
 * @export
 * @interface TableColumnRenameHintsDto
 */
export interface TableColumnRenameHintsDto {
    /**
     * 
     * @type {number}
     * @memberof TableColumnRenameHintsDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TableColumnRenameHintsDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TableColumnRenameHintsDto
     */
    'snapshotId'?: number;
    /**
     * 
     * @type {Array<HintEntry>}
     * @memberof TableColumnRenameHintsDto
     */
    'hints'?: Array<HintEntry> | null;
}
/**
 * 
 * @export
 * @interface TableObfsMappingCountDto
 */
export interface TableObfsMappingCountDto {
    /**
     * 
     * @type {number}
     * @memberof TableObfsMappingCountDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TableObfsMappingCountDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TableObfsMappingCountDto
     */
    'tableId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TableObfsMappingCountDto
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableObfsMappingCountDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableObfsMappingCountDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TableObfsMappingCountDto
     */
    'obfsMappedCount'?: number;
}
/**
 * 
 * @export
 * @interface TableSchemaAndNameDto
 */
export interface TableSchemaAndNameDto {
    /**
     * 
     * @type {string}
     * @memberof TableSchemaAndNameDto
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableSchemaAndNameDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TableSchemaAndNameDto
     */
    'totalRows'?: number | null;
}
/**
 * 
 * @export
 * @interface TableWithRefsResponseDto
 */
export interface TableWithRefsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TableWithRefsResponseDto
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableWithRefsResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TableWithRefsResponseDto
     */
    'totalRows'?: number | null;
    /**
     * 
     * @type {Array<TableSchemaAndNameDto>}
     * @memberof TableWithRefsResponseDto
     */
    'refs'?: Array<TableSchemaAndNameDto> | null;
}
/**
 * 
 * @export
 * @interface UpdateDataInfoTypeInput
 */
export interface UpdateDataInfoTypeInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateDataInfoTypeInput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDataInfoTypeInput
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDataInfoTypeInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<DataType>}
     * @memberof UpdateDataInfoTypeInput
     */
    'dataTypes'?: Array<DataType> | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDataInfoTypeInput
     */
    'minLength'?: number | null;
    /**
     * 
     * @type {Array<DetectPattern>}
     * @memberof UpdateDataInfoTypeInput
     */
    'detectPatterns'?: Array<DetectPattern> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDataInfoTypeInput
     */
    'validateFunction'?: string | null;
    /**
     * 
     * @type {Array<KeywordRule>}
     * @memberof UpdateDataInfoTypeInput
     */
    'keywordRules'?: Array<KeywordRule> | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDataInfoTypeInput
     */
    'defaultSecondClassification'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDataInfoTypeInput
     */
    'defaultEncryptionRule'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDataInfoTypeInput
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateDatabaseEncryptionKeyInput
 */
export interface UpdateDatabaseEncryptionKeyInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseEncryptionKeyInput
     */
    'databaseId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseEncryptionKeyInput
     */
    'encryptionKeyId': number;
}
/**
 * 
 * @export
 * @interface UpdateDatabaseSubsetLimitInput
 */
export interface UpdateDatabaseSubsetLimitInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseSubsetLimitInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseSubsetLimitInput
     */
    'subsetLimit'?: number;
}
/**
 * 
 * @export
 * @interface UpdateObfuscationRuleInput
 */
export interface UpdateObfuscationRuleInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateObfuscationRuleInput
     */
    'ruleId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateObfuscationRuleInput
     */
    'ruleName': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateObfuscationRuleInput
     */
    'databaseId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateObfuscationRuleInput
     */
    'tableId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateObfuscationRuleInput
     */
    'fieldId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateObfuscationRuleInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateObfuscationRuleInput
     */
    'valuesList'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateObfuscationRuleInput
     */
    'rangeValues'?: Array<string> | null;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof UpdateObfuscationRuleInput
     */
    'rangeBorders'?: Array<boolean> | null;
    /**
     * 
     * @type {InferredInfo}
     * @memberof UpdateObfuscationRuleInput
     */
    'inferredType': InferredInfo;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum UpgradeStatus {
    Unlocked = 0,
    Locked = 1,
    InProgress = 2,
    Success = 3,
    Failed = 4
}

/**
 * 
 * @export
 * @interface UpsertDataAccessPolicyInput
 */
export interface UpsertDataAccessPolicyInput {
    /**
     * 
     * @type {number}
     * @memberof UpsertDataAccessPolicyInput
     */
    'validationKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertDataAccessPolicyInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertDataAccessPolicyInput
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertDataAccessPolicyInput
     */
    'fingerPrint'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertDataAccessPolicyInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertDataAccessPolicyInput
     */
    'validationKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertDataAccessPolicyInput
     */
    'oidcDomain'?: string | null;
}

/**
 * DataAnalyzeApi - axios parameter creator
 * @export
 */
export const DataAnalyzeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataclassificationrulesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/dataclassificationrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DataClassificationRuleInput} [dataClassificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataclassificationrulesPost: async (dataClassificationRuleInput?: DataClassificationRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/dataclassificationrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataClassificationRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataclassificationrulesRuleIdDelete: async (ruleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiDataanalyzeDataclassificationrulesRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/api/dataanalyze/dataclassificationrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {DataClassificationRuleInput} [dataClassificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataclassificationrulesRuleIdPut: async (ruleId: number, dataClassificationRuleInput?: DataClassificationRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiDataanalyzeDataclassificationrulesRuleIdPut', 'ruleId', ruleId)
            const localVarPath = `/api/dataanalyze/dataclassificationrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataClassificationRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataprotectionruleGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/dataprotectionrule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DataProtectionRuleInput} [dataProtectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataprotectionrulePost: async (dataProtectionRuleInput?: DataProtectionRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/dataprotectionrule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataProtectionRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataprotectionruleRuleIdDelete: async (ruleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiDataanalyzeDataprotectionruleRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/api/dataanalyze/dataprotectionrule/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {DataProtectionRuleInput} [dataProtectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataprotectionruleRuleIdPut: async (ruleId: number, dataProtectionRuleInput?: DataProtectionRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiDataanalyzeDataprotectionruleRuleIdPut', 'ruleId', ruleId)
            const localVarPath = `/api/dataanalyze/dataprotectionrule/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataProtectionRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/infotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeInfotypesIdDelete', 'id', id)
            const localVarPath = `/api/dataanalyze/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeInfotypesIdGet', 'id', id)
            const localVarPath = `/api/dataanalyze/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDataInfoTypeInput} [updateDataInfoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdPut: async (id: string, updateDataInfoTypeInput?: UpdateDataInfoTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeInfotypesIdPut', 'id', id)
            const localVarPath = `/api/dataanalyze/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDataInfoTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDataInfoTypeInput} [createDataInfoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesPost: async (createDataInfoTypeInput?: CreateDataInfoTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/infotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDataInfoTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeValidatefunctionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/validatefunctions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataAnalyzeApi - functional programming interface
 * @export
 */
export const DataAnalyzeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataAnalyzeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDataclassificationrulesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataClassificationRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDataclassificationrulesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DataClassificationRuleInput} [dataClassificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDataclassificationrulesPost(dataClassificationRuleInput?: DataClassificationRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDataclassificationrulesPost(dataClassificationRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDataclassificationrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDataclassificationrulesRuleIdDelete(ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {DataClassificationRuleInput} [dataClassificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDataclassificationrulesRuleIdPut(ruleId: number, dataClassificationRuleInput?: DataClassificationRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDataclassificationrulesRuleIdPut(ruleId, dataClassificationRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDataprotectionruleGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataProtectionRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDataprotectionruleGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DataProtectionRuleInput} [dataProtectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDataprotectionrulePost(dataProtectionRuleInput?: DataProtectionRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDataprotectionrulePost(dataProtectionRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDataprotectionruleRuleIdDelete(ruleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDataprotectionruleRuleIdDelete(ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {DataProtectionRuleInput} [dataProtectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDataprotectionruleRuleIdPut(ruleId: number, dataProtectionRuleInput?: DataProtectionRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDataprotectionruleRuleIdPut(ruleId, dataProtectionRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataInfoTypeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataInfoTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDataInfoTypeInput} [updateDataInfoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesIdPut(id: string, updateDataInfoTypeInput?: UpdateDataInfoTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesIdPut(id, updateDataInfoTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDataInfoTypeInput} [createDataInfoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesPost(createDataInfoTypeInput?: CreateDataInfoTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataInfoTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesPost(createDataInfoTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeValidatefunctionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InfoTypeValidateFunctionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeValidatefunctionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataAnalyzeApi - factory interface
 * @export
 */
export const DataAnalyzeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataAnalyzeApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataclassificationrulesGet(options?: any): AxiosPromise<Array<DataClassificationRuleDto>> {
            return localVarFp.apiDataanalyzeDataclassificationrulesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataClassificationRuleInput} [dataClassificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataclassificationrulesPost(dataClassificationRuleInput?: DataClassificationRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeDataclassificationrulesPost(dataClassificationRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataclassificationrulesRuleIdDelete(ruleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeDataclassificationrulesRuleIdDelete(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {DataClassificationRuleInput} [dataClassificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataclassificationrulesRuleIdPut(ruleId: number, dataClassificationRuleInput?: DataClassificationRuleInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiDataanalyzeDataclassificationrulesRuleIdPut(ruleId, dataClassificationRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataprotectionruleGet(options?: any): AxiosPromise<Array<DataProtectionRuleDto>> {
            return localVarFp.apiDataanalyzeDataprotectionruleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataProtectionRuleInput} [dataProtectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataprotectionrulePost(dataProtectionRuleInput?: DataProtectionRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeDataprotectionrulePost(dataProtectionRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataprotectionruleRuleIdDelete(ruleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeDataprotectionruleRuleIdDelete(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {DataProtectionRuleInput} [dataProtectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDataprotectionruleRuleIdPut(ruleId: number, dataProtectionRuleInput?: DataProtectionRuleInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiDataanalyzeDataprotectionruleRuleIdPut(ruleId, dataProtectionRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesGet(options?: any): AxiosPromise<Array<DataInfoTypeResponseDto>> {
            return localVarFp.apiDataanalyzeInfotypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeInfotypesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdGet(id: string, options?: any): AxiosPromise<DataInfoTypeResponseDto> {
            return localVarFp.apiDataanalyzeInfotypesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDataInfoTypeInput} [updateDataInfoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdPut(id: string, updateDataInfoTypeInput?: UpdateDataInfoTypeInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeInfotypesIdPut(id, updateDataInfoTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDataInfoTypeInput} [createDataInfoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesPost(createDataInfoTypeInput?: CreateDataInfoTypeInput, options?: any): AxiosPromise<DataInfoTypeResponseDto> {
            return localVarFp.apiDataanalyzeInfotypesPost(createDataInfoTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeValidatefunctionsGet(options?: any): AxiosPromise<Array<InfoTypeValidateFunctionDto>> {
            return localVarFp.apiDataanalyzeValidatefunctionsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataAnalyzeApi - object-oriented interface
 * @export
 * @class DataAnalyzeApi
 * @extends {BaseAPI}
 */
export class DataAnalyzeApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeDataclassificationrulesGet(options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeDataclassificationrulesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataClassificationRuleInput} [dataClassificationRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeDataclassificationrulesPost(dataClassificationRuleInput?: DataClassificationRuleInput, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeDataclassificationrulesPost(dataClassificationRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeDataclassificationrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeDataclassificationrulesRuleIdDelete(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {DataClassificationRuleInput} [dataClassificationRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeDataclassificationrulesRuleIdPut(ruleId: number, dataClassificationRuleInput?: DataClassificationRuleInput, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeDataclassificationrulesRuleIdPut(ruleId, dataClassificationRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeDataprotectionruleGet(options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeDataprotectionruleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataProtectionRuleInput} [dataProtectionRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeDataprotectionrulePost(dataProtectionRuleInput?: DataProtectionRuleInput, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeDataprotectionrulePost(dataProtectionRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeDataprotectionruleRuleIdDelete(ruleId: number, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeDataprotectionruleRuleIdDelete(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {DataProtectionRuleInput} [dataProtectionRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeDataprotectionruleRuleIdPut(ruleId: number, dataProtectionRuleInput?: DataProtectionRuleInput, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeDataprotectionruleRuleIdPut(ruleId, dataProtectionRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeInfotypesGet(options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeInfotypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeInfotypesIdDelete(id: string, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeInfotypesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeInfotypesIdGet(id: string, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeInfotypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDataInfoTypeInput} [updateDataInfoTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeInfotypesIdPut(id: string, updateDataInfoTypeInput?: UpdateDataInfoTypeInput, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeInfotypesIdPut(id, updateDataInfoTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDataInfoTypeInput} [createDataInfoTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeInfotypesPost(createDataInfoTypeInput?: CreateDataInfoTypeInput, options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeInfotypesPost(createDataInfoTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyzeApi
     */
    public apiDataanalyzeValidatefunctionsGet(options?: AxiosRequestConfig) {
        return DataAnalyzeApiFp(this.configuration).apiDataanalyzeValidatefunctionsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EncryptionKeysApi - axios parameter creator
 * @export
 */
export const EncryptionKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UpdateDatabaseEncryptionKeyInput} [updateDatabaseEncryptionKeyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysAssignPost: async (updateDatabaseEncryptionKeyInput?: UpdateDatabaseEncryptionKeyInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptionkeys/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDatabaseEncryptionKeyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysDatabasesDatabaseIdGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionkeysDatabasesDatabaseIdGet', 'databaseId', databaseId)
            const localVarPath = `/api/encryptionkeys/databases/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} encryptionKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysEncryptionKeyIdDelete: async (encryptionKeyId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encryptionKeyId' is not null or undefined
            assertParamExists('apiEncryptionkeysEncryptionKeyIdDelete', 'encryptionKeyId', encryptionKeyId)
            const localVarPath = `/api/encryptionkeys/{encryptionKeyId}`
                .replace(`{${"encryptionKeyId"}}`, encodeURIComponent(String(encryptionKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptionkeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateEncryptionKeyInput} [createEncryptionKeyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysPost: async (createEncryptionKeyInput?: CreateEncryptionKeyInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptionkeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEncryptionKeyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EncryptionKeysApi - functional programming interface
 * @export
 */
export const EncryptionKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EncryptionKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UpdateDatabaseEncryptionKeyInput} [updateDatabaseEncryptionKeyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionkeysAssignPost(updateDatabaseEncryptionKeyInput?: UpdateDatabaseEncryptionKeyInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionkeysAssignPost(updateDatabaseEncryptionKeyInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionkeysDatabasesDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EncryptionKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionkeysDatabasesDatabaseIdGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} encryptionKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionkeysEncryptionKeyIdDelete(encryptionKeyId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionkeysEncryptionKeyIdDelete(encryptionKeyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionkeysGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncryptionKeyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionkeysGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateEncryptionKeyInput} [createEncryptionKeyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionkeysPost(createEncryptionKeyInput?: CreateEncryptionKeyInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionkeysPost(createEncryptionKeyInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EncryptionKeysApi - factory interface
 * @export
 */
export const EncryptionKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EncryptionKeysApiFp(configuration)
    return {
        /**
         * 
         * @param {UpdateDatabaseEncryptionKeyInput} [updateDatabaseEncryptionKeyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysAssignPost(updateDatabaseEncryptionKeyInput?: UpdateDatabaseEncryptionKeyInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionkeysAssignPost(updateDatabaseEncryptionKeyInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysDatabasesDatabaseIdGet(databaseId: number, options?: any): AxiosPromise<EncryptionKeyResponseDto> {
            return localVarFp.apiEncryptionkeysDatabasesDatabaseIdGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} encryptionKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysEncryptionKeyIdDelete(encryptionKeyId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionkeysEncryptionKeyIdDelete(encryptionKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysGet(options?: any): AxiosPromise<Array<EncryptionKeyResponseDto>> {
            return localVarFp.apiEncryptionkeysGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateEncryptionKeyInput} [createEncryptionKeyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionkeysPost(createEncryptionKeyInput?: CreateEncryptionKeyInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiEncryptionkeysPost(createEncryptionKeyInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EncryptionKeysApi - object-oriented interface
 * @export
 * @class EncryptionKeysApi
 * @extends {BaseAPI}
 */
export class EncryptionKeysApi extends BaseAPI {
    /**
     * 
     * @param {UpdateDatabaseEncryptionKeyInput} [updateDatabaseEncryptionKeyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionKeysApi
     */
    public apiEncryptionkeysAssignPost(updateDatabaseEncryptionKeyInput?: UpdateDatabaseEncryptionKeyInput, options?: AxiosRequestConfig) {
        return EncryptionKeysApiFp(this.configuration).apiEncryptionkeysAssignPost(updateDatabaseEncryptionKeyInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionKeysApi
     */
    public apiEncryptionkeysDatabasesDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionKeysApiFp(this.configuration).apiEncryptionkeysDatabasesDatabaseIdGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} encryptionKeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionKeysApi
     */
    public apiEncryptionkeysEncryptionKeyIdDelete(encryptionKeyId: number, options?: AxiosRequestConfig) {
        return EncryptionKeysApiFp(this.configuration).apiEncryptionkeysEncryptionKeyIdDelete(encryptionKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionKeysApi
     */
    public apiEncryptionkeysGet(options?: AxiosRequestConfig) {
        return EncryptionKeysApiFp(this.configuration).apiEncryptionkeysGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateEncryptionKeyInput} [createEncryptionKeyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionKeysApi
     */
    public apiEncryptionkeysPost(createEncryptionKeyInput?: CreateEncryptionKeyInput, options?: AxiosRequestConfig) {
        return EncryptionKeysApiFp(this.configuration).apiEncryptionkeysPost(createEncryptionKeyInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EncryptionsApi - axios parameter creator
 * @export
 */
export const EncryptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyClientIdClientIdGet: async (clientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiEncryptionsClientAccessPolicyClientIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/api/encryptions/clientAccessPolicy/{clientId}/clientId`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyClientIdsPost: async (requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/clientAccessPolicy/clientIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyDatabaseIdDatabaseGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsClientAccessPolicyDatabaseIdDatabaseGet', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/clientAccessPolicy/{databaseId}/database`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyDatabaseIdsPost: async (requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/clientAccessPolicy/databaseIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientAccessPolicyDto} [clientAccessPolicyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyPost: async (clientAccessPolicyDto?: ClientAccessPolicyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/clientAccessPolicy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientAccessPolicyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyTemplateIdFiletemplateGet: async (templateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('apiEncryptionsClientAccessPolicyTemplateIdFiletemplateGet', 'templateId', templateId)
            const localVarPath = `/api/encryptions/clientAccessPolicy/{templateId}/filetemplate`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyTemplateIdsPost: async (requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/clientAccessPolicy/templateIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDashboardGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {string} [createdTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDataAccessTokensDatabaseIdGet: async (databaseId: number, createdTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDataAccessTokensDatabaseIdGet', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/dataAccessTokens/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdTime !== undefined) {
                localVarQueryParameter['createdTime'] = createdTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {string} [createdTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDataAccessTokensDatabaseIdInvalidatePut: async (databaseId: number, createdTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDataAccessTokensDatabaseIdInvalidatePut', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/dataAccessTokens/{databaseId}/invalidate`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdTime !== undefined) {
                localVarQueryParameter['createdTime'] = createdTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {boolean} [validTokens] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDataAccessTokensGet: async (databaseId?: number, validTokens?: boolean, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/dataAccessTokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (validTokens !== undefined) {
                localVarQueryParameter['validTokens'] = validTokens;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DataAccessTokenCreationInput} [dataAccessTokenCreationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDataAccessTokensPost: async (dataAccessTokenCreationInput?: DataAccessTokenCreationInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/dataAccessTokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataAccessTokenCreationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DatabaseClientAccessPolicyDto} [databaseClientAccessPolicyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabaseClientAccessPolicyPost: async (databaseClientAccessPolicyDto?: DatabaseClientAccessPolicyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/databaseClientAccessPolicy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(databaseClientAccessPolicyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdFinalizePost: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDatabasesDatabaseIdFinalizePost', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/databases/{databaseId}/finalize`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDatabasesDatabaseIdGet', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/databases/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdLockPost: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDatabasesDatabaseIdLockPost', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/databases/{databaseId}/lock`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdRenameHintsGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDatabasesDatabaseIdRenameHintsGet', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/databases/{databaseId}/renameHints`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {TableColumnRenameHintsDto} [tableColumnRenameHintsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdRenameHintsPost: async (databaseId: number, tableColumnRenameHintsDto?: TableColumnRenameHintsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDatabasesDatabaseIdRenameHintsPost', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/databases/{databaseId}/renameHints`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tableColumnRenameHintsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdRollbackPost: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDatabasesDatabaseIdRollbackPost', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/databases/{databaseId}/rollback`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdSettingchangesGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDatabasesDatabaseIdSettingchangesGet', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/databases/{databaseId}/settingchanges`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdUnlockPost: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsDatabasesDatabaseIdUnlockPost', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/databases/{databaseId}/unlock`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesEncryptedGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/databases/encrypted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDetailGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDetailSuccessGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/detail/success`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [encryptionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDownloadGet: async (databaseId?: number, encryptionId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (encryptionId !== undefined) {
                localVarQueryParameter['encryptionId'] = encryptionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsJobsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ScheduleEncryptionInput} [scheduleEncryptionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPost: async (scheduleEncryptionInput?: ScheduleEncryptionInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleEncryptionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyDatabaseDatabaseIdGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsPublickeyDatabaseDatabaseIdGet', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/publickey/database/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyDatabaseDatabaseIdRegenerateManagedPost: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsPublickeyDatabaseDatabaseIdRegenerateManagedPost', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/publickey/database/{databaseId}/regenerate-managed`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyIsoverrideGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/publickey/isoverride`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyOrganizationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/publickey/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertDataAccessPolicyInput} [upsertDataAccessPolicyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyPost: async (upsertDataAccessPolicyInput?: UpsertDataAccessPolicyInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/publickey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertDataAccessPolicyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertDataAccessPolicyInput} [upsertDataAccessPolicyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyPut: async (upsertDataAccessPolicyInput?: UpsertDataAccessPolicyInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/publickey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertDataAccessPolicyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeySwitchoverrideDatabaseIdPut: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsPublickeySwitchoverrideDatabaseIdPut', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/publickey/switchoverride/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} [collectionId] 
         * @param {any} [sampleJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsSchemaCollectionPut: async (databaseId: number, collectionId?: number, sampleJson?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsSchemaCollectionPut', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/schema/collection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (databaseId !== undefined) { 
                localVarFormParams.append('DatabaseId', databaseId as any);
            }
    
            if (collectionId !== undefined) { 
                localVarFormParams.append('CollectionId', collectionId as any);
            }
    
            if (sampleJson !== undefined) { 
                localVarFormParams.append('SampleJson', sampleJson as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FileTemplateClientAccessPolicyDto} [fileTemplateClientAccessPolicyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsTemplateClientAccessPolicyPost: async (fileTemplateClientAccessPolicyDto?: FileTemplateClientAccessPolicyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/encryptions/templateClientAccessPolicy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileTemplateClientAccessPolicyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} validationKeyId 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsValidationKeyIdPublickeyDatabaseIdDelete: async (validationKeyId: number, databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validationKeyId' is not null or undefined
            assertParamExists('apiEncryptionsValidationKeyIdPublickeyDatabaseIdDelete', 'validationKeyId', validationKeyId)
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiEncryptionsValidationKeyIdPublickeyDatabaseIdDelete', 'databaseId', databaseId)
            const localVarPath = `/api/encryptions/{validationKeyId}/publickey/{databaseId}`
                .replace(`{${"validationKeyId"}}`, encodeURIComponent(String(validationKeyId)))
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EncryptionsApi - functional programming interface
 * @export
 */
export const EncryptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EncryptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsClientAccessPolicyClientIdClientIdGet(clientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAccessPolicyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsClientAccessPolicyClientIdClientIdGet(clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsClientAccessPolicyClientIdsPost(requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientAccessPolicyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsClientAccessPolicyClientIdsPost(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsClientAccessPolicyDatabaseIdDatabaseGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseClientAccessPolicyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsClientAccessPolicyDatabaseIdDatabaseGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsClientAccessPolicyDatabaseIdsPost(requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatabaseClientAccessPolicyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsClientAccessPolicyDatabaseIdsPost(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClientAccessPolicyDto} [clientAccessPolicyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsClientAccessPolicyPost(clientAccessPolicyDto?: ClientAccessPolicyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsClientAccessPolicyPost(clientAccessPolicyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsClientAccessPolicyTemplateIdFiletemplateGet(templateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileTemplateClientAccessPolicyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsClientAccessPolicyTemplateIdFiletemplateGet(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsClientAccessPolicyTemplateIdsPost(requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileTemplateClientAccessPolicyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsClientAccessPolicyTemplateIdsPost(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDashboardGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EncryptionDashboardResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDashboardGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {string} [createdTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDataAccessTokensDatabaseIdGet(databaseId: number, createdTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataAccessTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDataAccessTokensDatabaseIdGet(databaseId, createdTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {string} [createdTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDataAccessTokensDatabaseIdInvalidatePut(databaseId: number, createdTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDataAccessTokensDatabaseIdInvalidatePut(databaseId, createdTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {boolean} [validTokens] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDataAccessTokensGet(databaseId?: number, validTokens?: boolean, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataAccessTokenDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDataAccessTokensGet(databaseId, validTokens, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DataAccessTokenCreationInput} [dataAccessTokenCreationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDataAccessTokensPost(dataAccessTokenCreationInput?: DataAccessTokenCreationInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataAccessTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDataAccessTokensPost(dataAccessTokenCreationInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DatabaseClientAccessPolicyDto} [databaseClientAccessPolicyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabaseClientAccessPolicyPost(databaseClientAccessPolicyDto?: DatabaseClientAccessPolicyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabaseClientAccessPolicyPost(databaseClientAccessPolicyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabasesDatabaseIdFinalizePost(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabasesDatabaseIdFinalizePost(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabasesDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabasesDatabaseIdGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabasesDatabaseIdLockPost(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabasesDatabaseIdLockPost(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabasesDatabaseIdRenameHintsGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TableColumnRenameHintsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabasesDatabaseIdRenameHintsGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {TableColumnRenameHintsDto} [tableColumnRenameHintsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabasesDatabaseIdRenameHintsPost(databaseId: number, tableColumnRenameHintsDto?: TableColumnRenameHintsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabasesDatabaseIdRenameHintsPost(databaseId, tableColumnRenameHintsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabasesDatabaseIdRollbackPost(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabasesDatabaseIdRollbackPost(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabasesDatabaseIdSettingchangesGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EncryptionSettingChangesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabasesDatabaseIdSettingchangesGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabasesDatabaseIdUnlockPost(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabasesDatabaseIdUnlockPost(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDatabasesEncryptedGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatabaseResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDatabasesEncryptedGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDetailGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncryptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDetailGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDetailSuccessGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncryptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDetailSuccessGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [encryptionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsDownloadGet(databaseId?: number, encryptionId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsDownloadGet(databaseId, encryptionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsJobsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncryptionJobResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsJobsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ScheduleEncryptionInput} [scheduleEncryptionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsPost(scheduleEncryptionInput?: ScheduleEncryptionInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsPost(scheduleEncryptionInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsPublickeyDatabaseDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataAccessPolicyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsPublickeyDatabaseDatabaseIdGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsPublickeyDatabaseDatabaseIdRegenerateManagedPost(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsPublickeyDatabaseDatabaseIdRegenerateManagedPost(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsPublickeyIsoverrideGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsPublickeyIsoverrideGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsPublickeyOrganizationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataAccessPolicyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsPublickeyOrganizationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertDataAccessPolicyInput} [upsertDataAccessPolicyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsPublickeyPost(upsertDataAccessPolicyInput?: UpsertDataAccessPolicyInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsPublickeyPost(upsertDataAccessPolicyInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertDataAccessPolicyInput} [upsertDataAccessPolicyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsPublickeyPut(upsertDataAccessPolicyInput?: UpsertDataAccessPolicyInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsPublickeyPut(upsertDataAccessPolicyInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsPublickeySwitchoverrideDatabaseIdPut(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsPublickeySwitchoverrideDatabaseIdPut(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} [collectionId] 
         * @param {any} [sampleJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsSchemaCollectionPut(databaseId: number, collectionId?: number, sampleJson?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsSchemaCollectionPut(databaseId, collectionId, sampleJson, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FileTemplateClientAccessPolicyDto} [fileTemplateClientAccessPolicyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsTemplateClientAccessPolicyPost(fileTemplateClientAccessPolicyDto?: FileTemplateClientAccessPolicyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsTemplateClientAccessPolicyPost(fileTemplateClientAccessPolicyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} validationKeyId 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEncryptionsValidationKeyIdPublickeyDatabaseIdDelete(validationKeyId: number, databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEncryptionsValidationKeyIdPublickeyDatabaseIdDelete(validationKeyId, databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EncryptionsApi - factory interface
 * @export
 */
export const EncryptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EncryptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyClientIdClientIdGet(clientId: string, options?: any): AxiosPromise<ClientAccessPolicyResponseDto> {
            return localVarFp.apiEncryptionsClientAccessPolicyClientIdClientIdGet(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyClientIdsPost(requestBody?: Array<string>, options?: any): AxiosPromise<Array<ClientAccessPolicyResponseDto>> {
            return localVarFp.apiEncryptionsClientAccessPolicyClientIdsPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyDatabaseIdDatabaseGet(databaseId: number, options?: any): AxiosPromise<DatabaseClientAccessPolicyResponseDto> {
            return localVarFp.apiEncryptionsClientAccessPolicyDatabaseIdDatabaseGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyDatabaseIdsPost(requestBody?: Array<number>, options?: any): AxiosPromise<Array<DatabaseClientAccessPolicyResponseDto>> {
            return localVarFp.apiEncryptionsClientAccessPolicyDatabaseIdsPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientAccessPolicyDto} [clientAccessPolicyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyPost(clientAccessPolicyDto?: ClientAccessPolicyDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsClientAccessPolicyPost(clientAccessPolicyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyTemplateIdFiletemplateGet(templateId: number, options?: any): AxiosPromise<FileTemplateClientAccessPolicyResponseDto> {
            return localVarFp.apiEncryptionsClientAccessPolicyTemplateIdFiletemplateGet(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsClientAccessPolicyTemplateIdsPost(requestBody?: Array<number>, options?: any): AxiosPromise<Array<FileTemplateClientAccessPolicyResponseDto>> {
            return localVarFp.apiEncryptionsClientAccessPolicyTemplateIdsPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDashboardGet(options?: any): AxiosPromise<EncryptionDashboardResponseDto> {
            return localVarFp.apiEncryptionsDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {string} [createdTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDataAccessTokensDatabaseIdGet(databaseId: number, createdTime?: string, options?: any): AxiosPromise<DataAccessTokenDto> {
            return localVarFp.apiEncryptionsDataAccessTokensDatabaseIdGet(databaseId, createdTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {string} [createdTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDataAccessTokensDatabaseIdInvalidatePut(databaseId: number, createdTime?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsDataAccessTokensDatabaseIdInvalidatePut(databaseId, createdTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {boolean} [validTokens] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDataAccessTokensGet(databaseId?: number, validTokens?: boolean, page?: number, limit?: number, options?: any): AxiosPromise<DataAccessTokenDtoPaginationResult> {
            return localVarFp.apiEncryptionsDataAccessTokensGet(databaseId, validTokens, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataAccessTokenCreationInput} [dataAccessTokenCreationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDataAccessTokensPost(dataAccessTokenCreationInput?: DataAccessTokenCreationInput, options?: any): AxiosPromise<DataAccessTokenDto> {
            return localVarFp.apiEncryptionsDataAccessTokensPost(dataAccessTokenCreationInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DatabaseClientAccessPolicyDto} [databaseClientAccessPolicyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabaseClientAccessPolicyPost(databaseClientAccessPolicyDto?: DatabaseClientAccessPolicyDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsDatabaseClientAccessPolicyPost(databaseClientAccessPolicyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdFinalizePost(databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsDatabasesDatabaseIdFinalizePost(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdGet(databaseId: number, options?: any): AxiosPromise<DatabaseResponseDto> {
            return localVarFp.apiEncryptionsDatabasesDatabaseIdGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdLockPost(databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsDatabasesDatabaseIdLockPost(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdRenameHintsGet(databaseId: number, options?: any): AxiosPromise<TableColumnRenameHintsDto> {
            return localVarFp.apiEncryptionsDatabasesDatabaseIdRenameHintsGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {TableColumnRenameHintsDto} [tableColumnRenameHintsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdRenameHintsPost(databaseId: number, tableColumnRenameHintsDto?: TableColumnRenameHintsDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsDatabasesDatabaseIdRenameHintsPost(databaseId, tableColumnRenameHintsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdRollbackPost(databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsDatabasesDatabaseIdRollbackPost(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdSettingchangesGet(databaseId: number, options?: any): AxiosPromise<EncryptionSettingChangesResponseDto> {
            return localVarFp.apiEncryptionsDatabasesDatabaseIdSettingchangesGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesDatabaseIdUnlockPost(databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsDatabasesDatabaseIdUnlockPost(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDatabasesEncryptedGet(options?: any): AxiosPromise<Array<DatabaseResponseDto>> {
            return localVarFp.apiEncryptionsDatabasesEncryptedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDetailGet(databaseId?: number, options?: any): AxiosPromise<Array<EncryptionResponseDto>> {
            return localVarFp.apiEncryptionsDetailGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDetailSuccessGet(databaseId?: number, options?: any): AxiosPromise<Array<EncryptionResponseDto>> {
            return localVarFp.apiEncryptionsDetailSuccessGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [encryptionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsDownloadGet(databaseId?: number, encryptionId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsDownloadGet(databaseId, encryptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsJobsGet(options?: any): AxiosPromise<Array<EncryptionJobResponseDto>> {
            return localVarFp.apiEncryptionsJobsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ScheduleEncryptionInput} [scheduleEncryptionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPost(scheduleEncryptionInput?: ScheduleEncryptionInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsPost(scheduleEncryptionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyDatabaseDatabaseIdGet(databaseId: number, options?: any): AxiosPromise<Array<DataAccessPolicyResponseDto>> {
            return localVarFp.apiEncryptionsPublickeyDatabaseDatabaseIdGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyDatabaseDatabaseIdRegenerateManagedPost(databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsPublickeyDatabaseDatabaseIdRegenerateManagedPost(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyIsoverrideGet(databaseId?: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiEncryptionsPublickeyIsoverrideGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyOrganizationGet(options?: any): AxiosPromise<Array<DataAccessPolicyResponseDto>> {
            return localVarFp.apiEncryptionsPublickeyOrganizationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertDataAccessPolicyInput} [upsertDataAccessPolicyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyPost(upsertDataAccessPolicyInput?: UpsertDataAccessPolicyInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsPublickeyPost(upsertDataAccessPolicyInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertDataAccessPolicyInput} [upsertDataAccessPolicyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeyPut(upsertDataAccessPolicyInput?: UpsertDataAccessPolicyInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsPublickeyPut(upsertDataAccessPolicyInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsPublickeySwitchoverrideDatabaseIdPut(databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsPublickeySwitchoverrideDatabaseIdPut(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} [collectionId] 
         * @param {any} [sampleJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsSchemaCollectionPut(databaseId: number, collectionId?: number, sampleJson?: any, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsSchemaCollectionPut(databaseId, collectionId, sampleJson, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileTemplateClientAccessPolicyDto} [fileTemplateClientAccessPolicyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsTemplateClientAccessPolicyPost(fileTemplateClientAccessPolicyDto?: FileTemplateClientAccessPolicyDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsTemplateClientAccessPolicyPost(fileTemplateClientAccessPolicyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} validationKeyId 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEncryptionsValidationKeyIdPublickeyDatabaseIdDelete(validationKeyId: number, databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiEncryptionsValidationKeyIdPublickeyDatabaseIdDelete(validationKeyId, databaseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EncryptionsApi - object-oriented interface
 * @export
 * @class EncryptionsApi
 * @extends {BaseAPI}
 */
export class EncryptionsApi extends BaseAPI {
    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsClientAccessPolicyClientIdClientIdGet(clientId: string, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsClientAccessPolicyClientIdClientIdGet(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsClientAccessPolicyClientIdsPost(requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsClientAccessPolicyClientIdsPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsClientAccessPolicyDatabaseIdDatabaseGet(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsClientAccessPolicyDatabaseIdDatabaseGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsClientAccessPolicyDatabaseIdsPost(requestBody?: Array<number>, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsClientAccessPolicyDatabaseIdsPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientAccessPolicyDto} [clientAccessPolicyDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsClientAccessPolicyPost(clientAccessPolicyDto?: ClientAccessPolicyDto, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsClientAccessPolicyPost(clientAccessPolicyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsClientAccessPolicyTemplateIdFiletemplateGet(templateId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsClientAccessPolicyTemplateIdFiletemplateGet(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsClientAccessPolicyTemplateIdsPost(requestBody?: Array<number>, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsClientAccessPolicyTemplateIdsPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDashboardGet(options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {string} [createdTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDataAccessTokensDatabaseIdGet(databaseId: number, createdTime?: string, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDataAccessTokensDatabaseIdGet(databaseId, createdTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {string} [createdTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDataAccessTokensDatabaseIdInvalidatePut(databaseId: number, createdTime?: string, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDataAccessTokensDatabaseIdInvalidatePut(databaseId, createdTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {boolean} [validTokens] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDataAccessTokensGet(databaseId?: number, validTokens?: boolean, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDataAccessTokensGet(databaseId, validTokens, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataAccessTokenCreationInput} [dataAccessTokenCreationInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDataAccessTokensPost(dataAccessTokenCreationInput?: DataAccessTokenCreationInput, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDataAccessTokensPost(dataAccessTokenCreationInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DatabaseClientAccessPolicyDto} [databaseClientAccessPolicyDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabaseClientAccessPolicyPost(databaseClientAccessPolicyDto?: DatabaseClientAccessPolicyDto, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabaseClientAccessPolicyPost(databaseClientAccessPolicyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabasesDatabaseIdFinalizePost(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabasesDatabaseIdFinalizePost(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabasesDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabasesDatabaseIdGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabasesDatabaseIdLockPost(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabasesDatabaseIdLockPost(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabasesDatabaseIdRenameHintsGet(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabasesDatabaseIdRenameHintsGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {TableColumnRenameHintsDto} [tableColumnRenameHintsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabasesDatabaseIdRenameHintsPost(databaseId: number, tableColumnRenameHintsDto?: TableColumnRenameHintsDto, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabasesDatabaseIdRenameHintsPost(databaseId, tableColumnRenameHintsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabasesDatabaseIdRollbackPost(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabasesDatabaseIdRollbackPost(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabasesDatabaseIdSettingchangesGet(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabasesDatabaseIdSettingchangesGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabasesDatabaseIdUnlockPost(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabasesDatabaseIdUnlockPost(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDatabasesEncryptedGet(options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDatabasesEncryptedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDetailGet(databaseId?: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDetailGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDetailSuccessGet(databaseId?: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDetailSuccessGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {number} [encryptionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsDownloadGet(databaseId?: number, encryptionId?: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsDownloadGet(databaseId, encryptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsJobsGet(options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsJobsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ScheduleEncryptionInput} [scheduleEncryptionInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsPost(scheduleEncryptionInput?: ScheduleEncryptionInput, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsPost(scheduleEncryptionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsPublickeyDatabaseDatabaseIdGet(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsPublickeyDatabaseDatabaseIdGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsPublickeyDatabaseDatabaseIdRegenerateManagedPost(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsPublickeyDatabaseDatabaseIdRegenerateManagedPost(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsPublickeyIsoverrideGet(databaseId?: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsPublickeyIsoverrideGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsPublickeyOrganizationGet(options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsPublickeyOrganizationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertDataAccessPolicyInput} [upsertDataAccessPolicyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsPublickeyPost(upsertDataAccessPolicyInput?: UpsertDataAccessPolicyInput, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsPublickeyPost(upsertDataAccessPolicyInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertDataAccessPolicyInput} [upsertDataAccessPolicyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsPublickeyPut(upsertDataAccessPolicyInput?: UpsertDataAccessPolicyInput, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsPublickeyPut(upsertDataAccessPolicyInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsPublickeySwitchoverrideDatabaseIdPut(databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsPublickeySwitchoverrideDatabaseIdPut(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {number} [collectionId] 
     * @param {any} [sampleJson] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsSchemaCollectionPut(databaseId: number, collectionId?: number, sampleJson?: any, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsSchemaCollectionPut(databaseId, collectionId, sampleJson, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileTemplateClientAccessPolicyDto} [fileTemplateClientAccessPolicyDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsTemplateClientAccessPolicyPost(fileTemplateClientAccessPolicyDto?: FileTemplateClientAccessPolicyDto, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsTemplateClientAccessPolicyPost(fileTemplateClientAccessPolicyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} validationKeyId 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncryptionsApi
     */
    public apiEncryptionsValidationKeyIdPublickeyDatabaseIdDelete(validationKeyId: number, databaseId: number, options?: AxiosRequestConfig) {
        return EncryptionsApiFp(this.configuration).apiEncryptionsValidationKeyIdPublickeyDatabaseIdDelete(validationKeyId, databaseId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FileEncryptionApi - axios parameter creator
 * @export
 */
export const FileEncryptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DataKindCategory} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsDatatypeEncryptionRulesGet: async (category?: DataKindCategory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/file-encryptions/datatype/encryptionRules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/file-encryptions/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {FileTemplateKind} [kind] 
         * @param {string} [delimitingChar] 
         * @param {string} [escapeChar] 
         * @param {any} [templateFile] 
         * @param {number} [copyMappingFrom] 
         * @param {boolean} [copyIncludeObfs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesPost: async (name: string, kind?: FileTemplateKind, delimitingChar?: string, escapeChar?: string, templateFile?: any, copyMappingFrom?: number, copyIncludeObfs?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiFileEncryptionsTemplatesPost', 'name', name)
            const localVarPath = `/api/file-encryptions/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (kind !== undefined) { 
                localVarFormParams.append('Kind', kind as any);
            }
    
            if (delimitingChar !== undefined) { 
                localVarFormParams.append('DelimitingChar', delimitingChar as any);
            }
    
            if (escapeChar !== undefined) { 
                localVarFormParams.append('EscapeChar', escapeChar as any);
            }
    
            if (templateFile !== undefined) { 
                localVarFormParams.append('TemplateFile', templateFile as any);
            }
    
            if (copyMappingFrom !== undefined) { 
                localVarFormParams.append('CopyMappingFrom', copyMappingFrom as any);
            }
    
            if (copyIncludeObfs !== undefined) { 
                localVarFormParams.append('CopyIncludeObfs', copyIncludeObfs as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdDelete: async (templateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('apiFileEncryptionsTemplatesTemplateIdDelete', 'templateId', templateId)
            const localVarPath = `/api/file-encryptions/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdDownloadGet: async (templateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('apiFileEncryptionsTemplatesTemplateIdDownloadGet', 'templateId', templateId)
            const localVarPath = `/api/file-encryptions/templates/{templateId}/download`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdGet: async (templateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('apiFileEncryptionsTemplatesTemplateIdGet', 'templateId', templateId)
            const localVarPath = `/api/file-encryptions/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} templateId 
         * @param {CopyFileTemplateMappingInput} [copyFileTemplateMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdMappingsCopyPost: async (templateId: number, copyFileTemplateMappingInput?: CopyFileTemplateMappingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('apiFileEncryptionsTemplatesTemplateIdMappingsCopyPost', 'templateId', templateId)
            const localVarPath = `/api/file-encryptions/templates/{templateId}/mappings/copy`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyFileTemplateMappingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} templateId 
         * @param {EditFileTemplateInput} [editFileTemplateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdMappingsPost: async (templateId: number, editFileTemplateInput?: EditFileTemplateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('apiFileEncryptionsTemplatesTemplateIdMappingsPost', 'templateId', templateId)
            const localVarPath = `/api/file-encryptions/templates/{templateId}/mappings`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editFileTemplateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileEncryptionApi - functional programming interface
 * @export
 */
export const FileEncryptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileEncryptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DataKindCategory} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileEncryptionsDatatypeEncryptionRulesGet(category?: DataKindCategory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<EncryptionRule>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileEncryptionsDatatypeEncryptionRulesGet(category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileEncryptionsTemplatesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileEncryptionTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileEncryptionsTemplatesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {FileTemplateKind} [kind] 
         * @param {string} [delimitingChar] 
         * @param {string} [escapeChar] 
         * @param {any} [templateFile] 
         * @param {number} [copyMappingFrom] 
         * @param {boolean} [copyIncludeObfs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileEncryptionsTemplatesPost(name: string, kind?: FileTemplateKind, delimitingChar?: string, escapeChar?: string, templateFile?: any, copyMappingFrom?: number, copyIncludeObfs?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileEncryptionsTemplatesPost(name, kind, delimitingChar, escapeChar, templateFile, copyMappingFrom, copyIncludeObfs, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileEncryptionsTemplatesTemplateIdDelete(templateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileEncryptionsTemplatesTemplateIdDelete(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileEncryptionsTemplatesTemplateIdDownloadGet(templateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileEncryptionsTemplatesTemplateIdDownloadGet(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileEncryptionsTemplatesTemplateIdGet(templateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileEncryptionTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileEncryptionsTemplatesTemplateIdGet(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} templateId 
         * @param {CopyFileTemplateMappingInput} [copyFileTemplateMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileEncryptionsTemplatesTemplateIdMappingsCopyPost(templateId: number, copyFileTemplateMappingInput?: CopyFileTemplateMappingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileEncryptionsTemplatesTemplateIdMappingsCopyPost(templateId, copyFileTemplateMappingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} templateId 
         * @param {EditFileTemplateInput} [editFileTemplateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFileEncryptionsTemplatesTemplateIdMappingsPost(templateId: number, editFileTemplateInput?: EditFileTemplateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFileEncryptionsTemplatesTemplateIdMappingsPost(templateId, editFileTemplateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FileEncryptionApi - factory interface
 * @export
 */
export const FileEncryptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileEncryptionApiFp(configuration)
    return {
        /**
         * 
         * @param {DataKindCategory} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsDatatypeEncryptionRulesGet(category?: DataKindCategory, options?: any): AxiosPromise<{ [key: string]: Array<EncryptionRule>; }> {
            return localVarFp.apiFileEncryptionsDatatypeEncryptionRulesGet(category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesGet(options?: any): AxiosPromise<Array<FileEncryptionTemplateDto>> {
            return localVarFp.apiFileEncryptionsTemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {FileTemplateKind} [kind] 
         * @param {string} [delimitingChar] 
         * @param {string} [escapeChar] 
         * @param {any} [templateFile] 
         * @param {number} [copyMappingFrom] 
         * @param {boolean} [copyIncludeObfs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesPost(name: string, kind?: FileTemplateKind, delimitingChar?: string, escapeChar?: string, templateFile?: any, copyMappingFrom?: number, copyIncludeObfs?: boolean, options?: any): AxiosPromise<number> {
            return localVarFp.apiFileEncryptionsTemplatesPost(name, kind, delimitingChar, escapeChar, templateFile, copyMappingFrom, copyIncludeObfs, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdDelete(templateId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiFileEncryptionsTemplatesTemplateIdDelete(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdDownloadGet(templateId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiFileEncryptionsTemplatesTemplateIdDownloadGet(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdGet(templateId: number, options?: any): AxiosPromise<FileEncryptionTemplateDto> {
            return localVarFp.apiFileEncryptionsTemplatesTemplateIdGet(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} templateId 
         * @param {CopyFileTemplateMappingInput} [copyFileTemplateMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdMappingsCopyPost(templateId: number, copyFileTemplateMappingInput?: CopyFileTemplateMappingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFileEncryptionsTemplatesTemplateIdMappingsCopyPost(templateId, copyFileTemplateMappingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} templateId 
         * @param {EditFileTemplateInput} [editFileTemplateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFileEncryptionsTemplatesTemplateIdMappingsPost(templateId: number, editFileTemplateInput?: EditFileTemplateInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFileEncryptionsTemplatesTemplateIdMappingsPost(templateId, editFileTemplateInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileEncryptionApi - object-oriented interface
 * @export
 * @class FileEncryptionApi
 * @extends {BaseAPI}
 */
export class FileEncryptionApi extends BaseAPI {
    /**
     * 
     * @param {DataKindCategory} [category] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileEncryptionApi
     */
    public apiFileEncryptionsDatatypeEncryptionRulesGet(category?: DataKindCategory, options?: AxiosRequestConfig) {
        return FileEncryptionApiFp(this.configuration).apiFileEncryptionsDatatypeEncryptionRulesGet(category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileEncryptionApi
     */
    public apiFileEncryptionsTemplatesGet(options?: AxiosRequestConfig) {
        return FileEncryptionApiFp(this.configuration).apiFileEncryptionsTemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {FileTemplateKind} [kind] 
     * @param {string} [delimitingChar] 
     * @param {string} [escapeChar] 
     * @param {any} [templateFile] 
     * @param {number} [copyMappingFrom] 
     * @param {boolean} [copyIncludeObfs] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileEncryptionApi
     */
    public apiFileEncryptionsTemplatesPost(name: string, kind?: FileTemplateKind, delimitingChar?: string, escapeChar?: string, templateFile?: any, copyMappingFrom?: number, copyIncludeObfs?: boolean, options?: AxiosRequestConfig) {
        return FileEncryptionApiFp(this.configuration).apiFileEncryptionsTemplatesPost(name, kind, delimitingChar, escapeChar, templateFile, copyMappingFrom, copyIncludeObfs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileEncryptionApi
     */
    public apiFileEncryptionsTemplatesTemplateIdDelete(templateId: number, options?: AxiosRequestConfig) {
        return FileEncryptionApiFp(this.configuration).apiFileEncryptionsTemplatesTemplateIdDelete(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileEncryptionApi
     */
    public apiFileEncryptionsTemplatesTemplateIdDownloadGet(templateId: number, options?: AxiosRequestConfig) {
        return FileEncryptionApiFp(this.configuration).apiFileEncryptionsTemplatesTemplateIdDownloadGet(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileEncryptionApi
     */
    public apiFileEncryptionsTemplatesTemplateIdGet(templateId: number, options?: AxiosRequestConfig) {
        return FileEncryptionApiFp(this.configuration).apiFileEncryptionsTemplatesTemplateIdGet(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} templateId 
     * @param {CopyFileTemplateMappingInput} [copyFileTemplateMappingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileEncryptionApi
     */
    public apiFileEncryptionsTemplatesTemplateIdMappingsCopyPost(templateId: number, copyFileTemplateMappingInput?: CopyFileTemplateMappingInput, options?: AxiosRequestConfig) {
        return FileEncryptionApiFp(this.configuration).apiFileEncryptionsTemplatesTemplateIdMappingsCopyPost(templateId, copyFileTemplateMappingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} templateId 
     * @param {EditFileTemplateInput} [editFileTemplateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileEncryptionApi
     */
    public apiFileEncryptionsTemplatesTemplateIdMappingsPost(templateId: number, editFileTemplateInput?: EditFileTemplateInput, options?: AxiosRequestConfig) {
        return FileEncryptionApiFp(this.configuration).apiFileEncryptionsTemplatesTemplateIdMappingsPost(templateId, editFileTemplateInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MappingsApi - axios parameter creator
 * @export
 */
export const MappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMappingsRulesGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mappings/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MappingsApi - functional programming interface
 * @export
 */
export const MappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMappingsRulesGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncryptionRuleResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMappingsRulesGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MappingsApi - factory interface
 * @export
 */
export const MappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MappingsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMappingsRulesGet(databaseId?: number, options?: any): AxiosPromise<Array<EncryptionRuleResponseDto>> {
            return localVarFp.apiMappingsRulesGet(databaseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MappingsApi - object-oriented interface
 * @export
 * @class MappingsApi
 * @extends {BaseAPI}
 */
export class MappingsApi extends BaseAPI {
    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MappingsApi
     */
    public apiMappingsRulesGet(databaseId?: number, options?: AxiosRequestConfig) {
        return MappingsApiFp(this.configuration).apiMappingsRulesGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ObfuscationApi - axios parameter creator
 * @export
 */
export const ObfuscationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationDetailGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/obfuscation/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationJobsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/obfuscation/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationMappingsDatabasesDatabaseIdTablesGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiObfuscationMappingsDatabasesDatabaseIdTablesGet', 'databaseId', databaseId)
            const localVarPath = `/api/obfuscation/mappings/databases/{databaseId}/tables`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationMappingsDatabasesDatabaseIdTablesTableIdFieldsGet: async (databaseId: number, tableId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiObfuscationMappingsDatabasesDatabaseIdTablesTableIdFieldsGet', 'databaseId', databaseId)
            // verify required parameter 'tableId' is not null or undefined
            assertParamExists('apiObfuscationMappingsDatabasesDatabaseIdTablesTableIdFieldsGet', 'tableId', tableId)
            const localVarPath = `/api/obfuscation/mappings/databases/{databaseId}/tables/{tableId}/fields`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"tableId"}}`, encodeURIComponent(String(tableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationMappingsDatabasesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/obfuscation/mappings/databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditObfuscationMappingInput} [editObfuscationMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationMappingsEditPost: async (editObfuscationMappingInput?: EditObfuscationMappingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/obfuscation/mappings/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editObfuscationMappingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/obfuscation/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesOptionsDatabasesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/obfuscation/rules/options/databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [tableId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesOptionsFieldsGet: async (databaseId?: number, tableId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/obfuscation/rules/options/fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (tableId !== undefined) {
                localVarQueryParameter['tableId'] = tableId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesOptionsTablesGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/obfuscation/rules/options/tables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateObfuscationRuleInput} [createObfuscationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesPost: async (createObfuscationRuleInput?: CreateObfuscationRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/obfuscation/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createObfuscationRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {string} [suppressAlert] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesRuleIdDelete: async (ruleId: number, suppressAlert?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiObfuscationRulesRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/api/obfuscation/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (suppressAlert !== undefined) {
                localVarQueryParameter['suppressAlert'] = suppressAlert;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesRuleIdGet: async (ruleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiObfuscationRulesRuleIdGet', 'ruleId', ruleId)
            const localVarPath = `/api/obfuscation/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {string} [suppressAlert] 
         * @param {UpdateObfuscationRuleInput} [updateObfuscationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesRuleIdPut: async (ruleId: number, suppressAlert?: string, updateObfuscationRuleInput?: UpdateObfuscationRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiObfuscationRulesRuleIdPut', 'ruleId', ruleId)
            const localVarPath = `/api/obfuscation/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (suppressAlert !== undefined) {
                localVarQueryParameter['suppressAlert'] = suppressAlert;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateObfuscationRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesRuleIdQueryusageGet: async (ruleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiObfuscationRulesRuleIdQueryusageGet', 'ruleId', ruleId)
            const localVarPath = `/api/obfuscation/rules/{ruleId}/queryusage`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ruleName 
         * @param {ObfuscationDataType} dataType 
         * @param {string} [description] 
         * @param {any} [valuesFile] 
         * @param {number} [ruleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesUploadPost: async (ruleName: string, dataType: ObfuscationDataType, description?: string, valuesFile?: any, ruleId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleName' is not null or undefined
            assertParamExists('apiObfuscationRulesUploadPost', 'ruleName', ruleName)
            // verify required parameter 'dataType' is not null or undefined
            assertParamExists('apiObfuscationRulesUploadPost', 'dataType', dataType)
            const localVarPath = `/api/obfuscation/rules/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (ruleName !== undefined) { 
                localVarFormParams.append('RuleName', ruleName as any);
            }
    
            if (dataType !== undefined) { 
                localVarFormParams.append('DataType', dataType as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('Description', description as any);
            }
    
            if (valuesFile !== undefined) { 
                localVarFormParams.append('ValuesFile', valuesFile as any);
            }
    
            if (ruleId !== undefined) { 
                localVarFormParams.append('RuleId', ruleId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObfuscationApi - functional programming interface
 * @export
 */
export const ObfuscationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObfuscationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationDetailGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncryptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationDetailGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationJobsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EncryptionJobResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationJobsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationMappingsDatabasesDatabaseIdTablesGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableObfsMappingCountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationMappingsDatabasesDatabaseIdTablesGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId: number, tableId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FieldObfsMappingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId, tableId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationMappingsDatabasesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ObfuscationMappingResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationMappingsDatabasesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EditObfuscationMappingInput} [editObfuscationMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationMappingsEditPost(editObfuscationMappingInput?: EditObfuscationMappingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationMappingsEditPost(editObfuscationMappingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ObfuscationRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesOptionsDatabasesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatabaseOptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesOptionsDatabasesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [tableId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesOptionsFieldsGet(databaseId?: number, tableId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FieldResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesOptionsFieldsGet(databaseId, tableId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesOptionsTablesGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesOptionsTablesGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateObfuscationRuleInput} [createObfuscationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesPost(createObfuscationRuleInput?: CreateObfuscationRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesPost(createObfuscationRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {string} [suppressAlert] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesRuleIdDelete(ruleId: number, suppressAlert?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesRuleIdDelete(ruleId, suppressAlert, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesRuleIdGet(ruleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObfuscationRuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesRuleIdGet(ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {string} [suppressAlert] 
         * @param {UpdateObfuscationRuleInput} [updateObfuscationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesRuleIdPut(ruleId: number, suppressAlert?: string, updateObfuscationRuleInput?: UpdateObfuscationRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesRuleIdPut(ruleId, suppressAlert, updateObfuscationRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesRuleIdQueryusageGet(ruleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObfuscationRuleUsageBriefDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesRuleIdQueryusageGet(ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} ruleName 
         * @param {ObfuscationDataType} dataType 
         * @param {string} [description] 
         * @param {any} [valuesFile] 
         * @param {number} [ruleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiObfuscationRulesUploadPost(ruleName: string, dataType: ObfuscationDataType, description?: string, valuesFile?: any, ruleId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObfuscationRuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiObfuscationRulesUploadPost(ruleName, dataType, description, valuesFile, ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ObfuscationApi - factory interface
 * @export
 */
export const ObfuscationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObfuscationApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationDetailGet(databaseId?: number, options?: any): AxiosPromise<Array<EncryptionResponseDto>> {
            return localVarFp.apiObfuscationDetailGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationJobsGet(options?: any): AxiosPromise<Array<EncryptionJobResponseDto>> {
            return localVarFp.apiObfuscationJobsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationMappingsDatabasesDatabaseIdTablesGet(databaseId: number, options?: any): AxiosPromise<Array<TableObfsMappingCountDto>> {
            return localVarFp.apiObfuscationMappingsDatabasesDatabaseIdTablesGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {number} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId: number, tableId: number, options?: any): AxiosPromise<Array<FieldObfsMappingDto>> {
            return localVarFp.apiObfuscationMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId, tableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationMappingsDatabasesGet(options?: any): AxiosPromise<Array<ObfuscationMappingResponseDto>> {
            return localVarFp.apiObfuscationMappingsDatabasesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditObfuscationMappingInput} [editObfuscationMappingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationMappingsEditPost(editObfuscationMappingInput?: EditObfuscationMappingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiObfuscationMappingsEditPost(editObfuscationMappingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesGet(options?: any): AxiosPromise<Array<ObfuscationRuleDto>> {
            return localVarFp.apiObfuscationRulesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesOptionsDatabasesGet(options?: any): AxiosPromise<Array<DatabaseOptionResponseDto>> {
            return localVarFp.apiObfuscationRulesOptionsDatabasesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [tableId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesOptionsFieldsGet(databaseId?: number, tableId?: number, options?: any): AxiosPromise<Array<FieldResponseDto>> {
            return localVarFp.apiObfuscationRulesOptionsFieldsGet(databaseId, tableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesOptionsTablesGet(databaseId?: number, options?: any): AxiosPromise<Array<OptionResponseDto>> {
            return localVarFp.apiObfuscationRulesOptionsTablesGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateObfuscationRuleInput} [createObfuscationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesPost(createObfuscationRuleInput?: CreateObfuscationRuleInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiObfuscationRulesPost(createObfuscationRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {string} [suppressAlert] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesRuleIdDelete(ruleId: number, suppressAlert?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiObfuscationRulesRuleIdDelete(ruleId, suppressAlert, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesRuleIdGet(ruleId: number, options?: any): AxiosPromise<ObfuscationRuleDto> {
            return localVarFp.apiObfuscationRulesRuleIdGet(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {string} [suppressAlert] 
         * @param {UpdateObfuscationRuleInput} [updateObfuscationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesRuleIdPut(ruleId: number, suppressAlert?: string, updateObfuscationRuleInput?: UpdateObfuscationRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiObfuscationRulesRuleIdPut(ruleId, suppressAlert, updateObfuscationRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesRuleIdQueryusageGet(ruleId: number, options?: any): AxiosPromise<ObfuscationRuleUsageBriefDto> {
            return localVarFp.apiObfuscationRulesRuleIdQueryusageGet(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ruleName 
         * @param {ObfuscationDataType} dataType 
         * @param {string} [description] 
         * @param {any} [valuesFile] 
         * @param {number} [ruleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiObfuscationRulesUploadPost(ruleName: string, dataType: ObfuscationDataType, description?: string, valuesFile?: any, ruleId?: number, options?: any): AxiosPromise<ObfuscationRuleDto> {
            return localVarFp.apiObfuscationRulesUploadPost(ruleName, dataType, description, valuesFile, ruleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObfuscationApi - object-oriented interface
 * @export
 * @class ObfuscationApi
 * @extends {BaseAPI}
 */
export class ObfuscationApi extends BaseAPI {
    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationDetailGet(databaseId?: number, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationDetailGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationJobsGet(options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationJobsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationMappingsDatabasesDatabaseIdTablesGet(databaseId: number, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationMappingsDatabasesDatabaseIdTablesGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {number} tableId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId: number, tableId: number, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationMappingsDatabasesDatabaseIdTablesTableIdFieldsGet(databaseId, tableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationMappingsDatabasesGet(options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationMappingsDatabasesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditObfuscationMappingInput} [editObfuscationMappingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationMappingsEditPost(editObfuscationMappingInput?: EditObfuscationMappingInput, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationMappingsEditPost(editObfuscationMappingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesGet(options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesOptionsDatabasesGet(options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesOptionsDatabasesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {number} [tableId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesOptionsFieldsGet(databaseId?: number, tableId?: number, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesOptionsFieldsGet(databaseId, tableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesOptionsTablesGet(databaseId?: number, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesOptionsTablesGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateObfuscationRuleInput} [createObfuscationRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesPost(createObfuscationRuleInput?: CreateObfuscationRuleInput, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesPost(createObfuscationRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {string} [suppressAlert] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesRuleIdDelete(ruleId: number, suppressAlert?: string, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesRuleIdDelete(ruleId, suppressAlert, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesRuleIdGet(ruleId: number, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesRuleIdGet(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {string} [suppressAlert] 
     * @param {UpdateObfuscationRuleInput} [updateObfuscationRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesRuleIdPut(ruleId: number, suppressAlert?: string, updateObfuscationRuleInput?: UpdateObfuscationRuleInput, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesRuleIdPut(ruleId, suppressAlert, updateObfuscationRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesRuleIdQueryusageGet(ruleId: number, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesRuleIdQueryusageGet(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ruleName 
     * @param {ObfuscationDataType} dataType 
     * @param {string} [description] 
     * @param {any} [valuesFile] 
     * @param {number} [ruleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObfuscationApi
     */
    public apiObfuscationRulesUploadPost(ruleName: string, dataType: ObfuscationDataType, description?: string, valuesFile?: any, ruleId?: number, options?: AxiosRequestConfig) {
        return ObfuscationApiFp(this.configuration).apiObfuscationRulesUploadPost(ruleName, dataType, description, valuesFile, ruleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SubsetApi - axios parameter creator
 * @export
 */
export const SubsetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UpdateDatabaseSubsetLimitInput} [updateDatabaseSubsetLimitInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubsetLimitPost: async (updateDatabaseSubsetLimitInput?: UpdateDatabaseSubsetLimitInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subset/limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDatabaseSubsetLimitInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubsetMastertablesGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subset/mastertables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddSubsetMasterTablesInput} [addSubsetMasterTablesInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubsetMastertablesPost: async (addSubsetMasterTablesInput?: AddSubsetMasterTablesInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subset/mastertables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSubsetMasterTablesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubsetTableswithrefsGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subset/tableswithrefs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubsetApi - functional programming interface
 * @export
 */
export const SubsetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubsetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UpdateDatabaseSubsetLimitInput} [updateDatabaseSubsetLimitInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubsetLimitPost(updateDatabaseSubsetLimitInput?: UpdateDatabaseSubsetLimitInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubsetLimitPost(updateDatabaseSubsetLimitInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubsetMastertablesGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubsetMasterTableResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubsetMastertablesGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddSubsetMasterTablesInput} [addSubsetMasterTablesInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubsetMastertablesPost(addSubsetMasterTablesInput?: AddSubsetMasterTablesInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubsetMastertablesPost(addSubsetMasterTablesInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubsetTableswithrefsGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableWithRefsResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubsetTableswithrefsGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubsetApi - factory interface
 * @export
 */
export const SubsetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubsetApiFp(configuration)
    return {
        /**
         * 
         * @param {UpdateDatabaseSubsetLimitInput} [updateDatabaseSubsetLimitInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubsetLimitPost(updateDatabaseSubsetLimitInput?: UpdateDatabaseSubsetLimitInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiSubsetLimitPost(updateDatabaseSubsetLimitInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubsetMastertablesGet(databaseId?: number, options?: any): AxiosPromise<Array<SubsetMasterTableResponseDto>> {
            return localVarFp.apiSubsetMastertablesGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddSubsetMasterTablesInput} [addSubsetMasterTablesInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubsetMastertablesPost(addSubsetMasterTablesInput?: AddSubsetMasterTablesInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiSubsetMastertablesPost(addSubsetMasterTablesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubsetTableswithrefsGet(databaseId?: number, options?: any): AxiosPromise<Array<TableWithRefsResponseDto>> {
            return localVarFp.apiSubsetTableswithrefsGet(databaseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubsetApi - object-oriented interface
 * @export
 * @class SubsetApi
 * @extends {BaseAPI}
 */
export class SubsetApi extends BaseAPI {
    /**
     * 
     * @param {UpdateDatabaseSubsetLimitInput} [updateDatabaseSubsetLimitInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubsetApi
     */
    public apiSubsetLimitPost(updateDatabaseSubsetLimitInput?: UpdateDatabaseSubsetLimitInput, options?: AxiosRequestConfig) {
        return SubsetApiFp(this.configuration).apiSubsetLimitPost(updateDatabaseSubsetLimitInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubsetApi
     */
    public apiSubsetMastertablesGet(databaseId?: number, options?: AxiosRequestConfig) {
        return SubsetApiFp(this.configuration).apiSubsetMastertablesGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddSubsetMasterTablesInput} [addSubsetMasterTablesInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubsetApi
     */
    public apiSubsetMastertablesPost(addSubsetMasterTablesInput?: AddSubsetMasterTablesInput, options?: AxiosRequestConfig) {
        return SubsetApiFp(this.configuration).apiSubsetMastertablesPost(addSubsetMasterTablesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubsetApi
     */
    public apiSubsetTableswithrefsGet(databaseId?: number, options?: AxiosRequestConfig) {
        return SubsetApiFp(this.configuration).apiSubsetTableswithrefsGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }
}


